(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-json'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-json'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-json'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-json'], globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var EmptySerializersModule = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d2;
  var protoOf = kotlin_kotlin.$_$.tc;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var VOID = kotlin_kotlin.$_$.i;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var StringFormat = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n2;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var toString = kotlin_kotlin.$_$.xc;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var charSequenceLength = kotlin_kotlin.$_$.db;
  var charSequenceGet = kotlin_kotlin.$_$.cb;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.p2;
  var equals = kotlin_kotlin.$_$.hb;
  var toString_0 = kotlin_kotlin.$_$.ci;
  var Enum = kotlin_kotlin.$_$.mg;
  var Decoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n1;
  var CompositeDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l1;
  var initMetadataForInterface = kotlin_kotlin.$_$.ub;
  var initMetadataForCompanion = kotlin_kotlin.$_$.rb;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.j1;
  var hashCode = kotlin_kotlin.$_$.pb;
  var joinToString = kotlin_kotlin.$_$.r7;
  var THROW_CCE = kotlin_kotlin.$_$.wg;
  var KtMap = kotlin_kotlin.$_$.q5;
  var KtList = kotlin_kotlin.$_$.o5;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var getBooleanHashCode = kotlin_kotlin.$_$.kb;
  var getStringHashCode = kotlin_kotlin.$_$.ob;
  var NumberFormatException_init_$Create$ = kotlin_kotlin.$_$.g2;
  var numberRangeToNumber = kotlin_kotlin.$_$.nc;
  var ClosedRange = kotlin_kotlin.$_$.bd;
  var isInterface = kotlin_kotlin.$_$.gc;
  var contains = kotlin_kotlin.$_$.hd;
  var toDouble = kotlin_kotlin.$_$.mf;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.t4;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var InlinePrimitiveDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.y;
  var SEALED_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d;
  var buildSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.wh;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i2;
  var MapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var SerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f1;
  var STRING_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var ListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var ENUM_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g;
  var PrimitiveSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b1;
  var toLongOrNull = kotlin_kotlin.$_$.qf;
  var toULongOrNull = kotlin_kotlin.$_$.vf;
  var ULong = kotlin_kotlin.$_$.fh;
  var Companion_getInstance = kotlin_kotlin.$_$.c5;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.y;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.u3;
  var toDoubleOrNull = kotlin_kotlin.$_$.lf;
  var toBooleanStrictOrNull = kotlin_kotlin.$_$.jf;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.z1;
  var lazy = kotlin_kotlin.$_$.vh;
  var get_isNullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e1;
  var get_isInline = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.d1;
  var get_annotations = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c1;
  var KProperty1 = kotlin_kotlin.$_$.od;
  var getPropertyCallableRef = kotlin_kotlin.$_$.nb;
  var Encoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o1;
  var CompositeEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m1;
  var toLong = kotlin_kotlin.$_$.vc;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.k3;
  var UInt__toString_impl_dbgl21 = kotlin_kotlin.$_$.m3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.t3;
  var ULong__toString_impl_f9au7k = kotlin_kotlin.$_$.v3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.b3;
  var UByte__toString_impl_v72jg = kotlin_kotlin.$_$.d3;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.c4;
  var UShort__toString_impl_edaoee = kotlin_kotlin.$_$.e4;
  var ElementMarker = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r1;
  var captureStack = kotlin_kotlin.$_$.za;
  var SerializationException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l2;
  var SerializationException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var charSequenceSubSequence = kotlin_kotlin.$_$.eb;
  var coerceAtLeast = kotlin_kotlin.$_$.dd;
  var coerceAtMost = kotlin_kotlin.$_$.ed;
  var SerializationException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var CLASS_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.p;
  var singleOrNull = kotlin_kotlin.$_$.b9;
  var emptyMap = kotlin_kotlin.$_$.y6;
  var getValue = kotlin_kotlin.$_$.l7;
  var fillArrayVal = kotlin_kotlin.$_$.jb;
  var copyOf = kotlin_kotlin.$_$.q6;
  var copyOf_0 = kotlin_kotlin.$_$.r6;
  var LIST_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i;
  var DeepRecursiveFunction = kotlin_kotlin.$_$.kg;
  var invoke = kotlin_kotlin.$_$.qh;
  var CoroutineImpl = kotlin_kotlin.$_$.qa;
  var DeepRecursiveScope = kotlin_kotlin.$_$.lg;
  var Unit = kotlin_kotlin.$_$.ih;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.aa;
  var initMetadataForLambda = kotlin_kotlin.$_$.vb;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.sb;
  var SealedClassSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var jsonCachedSerialNames = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var ENUM = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.g1;
  var PrimitiveKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a1;
  var PolymorphicKind = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z;
  var CONTEXTUAL_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f;
  var MAP_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j;
  var contextual = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var SerializersModuleCollector = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var AbstractDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j1;
  var AbstractPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p1;
  var DeserializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.h2;
  var getKClass = kotlin_kotlin.$_$.f;
  var findPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o2;
  var ensureNotNull = kotlin_kotlin.$_$.ph;
  var substringBefore = kotlin_kotlin.$_$.hf;
  var removeSuffix = kotlin_kotlin.$_$.xe;
  var substringAfter = kotlin_kotlin.$_$.ef;
  var contains_0 = kotlin_kotlin.$_$.wd;
  var plus = kotlin_kotlin.$_$.xh;
  var MissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.j2;
  var IllegalArgumentException = kotlin_kotlin.$_$.pg;
  var isFinite = kotlin_kotlin.$_$.sh;
  var isFinite_0 = kotlin_kotlin.$_$.rh;
  var toUInt = kotlin_kotlin.$_$.uf;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.l3;
  var toULong = kotlin_kotlin.$_$.wf;
  var toUByte = kotlin_kotlin.$_$.tf;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.c3;
  var toUShort = kotlin_kotlin.$_$.xf;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.d4;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var AbstractEncoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k1;
  var OBJECT_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k;
  var findPolymorphicSerializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p2;
  var SerializationStrategy = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m2;
  var toString_1 = kotlin_kotlin.$_$.w2;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.b5;
  var serializer_1 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.a5;
  var serializer_2 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.d5;
  var serializer_3 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var setOf = kotlin_kotlin.$_$.a9;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.v2;
  var numberToChar = kotlin_kotlin.$_$.oc;
  var equals_0 = kotlin_kotlin.$_$.fe;
  var startsWith = kotlin_kotlin.$_$.cf;
  var NamedValueDecoder = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.x1;
  var toByte = kotlin_kotlin.$_$.uc;
  var toShort = kotlin_kotlin.$_$.wc;
  var single = kotlin_kotlin.$_$.af;
  var Char = kotlin_kotlin.$_$.hg;
  var emptySet = kotlin_kotlin.$_$.z6;
  var plus_0 = kotlin_kotlin.$_$.o8;
  var toInt = kotlin_kotlin.$_$.of;
  var toList = kotlin_kotlin.$_$.n9;
  var enumEntries = kotlin_kotlin.$_$.sa;
  var getContextualDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.i1;
  var last = kotlin_kotlin.$_$.w7;
  var removeLast = kotlin_kotlin.$_$.w8;
  var lastIndexOf = kotlin_kotlin.$_$.se;
  var Long = kotlin_kotlin.$_$.rg;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.r2;
  var numberToLong = kotlin_kotlin.$_$.rc;
  var charArray = kotlin_kotlin.$_$.bb;
  var indexOf = kotlin_kotlin.$_$.ie;
  var indexOf_0 = kotlin_kotlin.$_$.je;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.i1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.r;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
  initMetadataForObject(Default, 'Default', VOID, Json);
  initMetadataForClass(JsonBuilder, 'JsonBuilder');
  initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
  initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
  initMetadataForClass(JsonNames, 'JsonNames');
  initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
  initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
  initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
  initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
  initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
  initMetadataForClass(JsonObjectBuilder, 'JsonObjectBuilder');
  initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
  initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(Composer, 'Composer');
  initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
  initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
  initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
  initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
  initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
  initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
  initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
  initMetadataForObject(Tombstone, 'Tombstone');
  initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
  initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($readObjectCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [0]);
  initMetadataForClass(PolymorphismValidator, 'PolymorphismValidator', VOID, VOID, [SerializersModuleCollector]);
  initMetadataForClass(Key, 'Key', Key);
  initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
  initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
  initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
  initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
  initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
  initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
  initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
  initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
  initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
  initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
  initMetadataForObject(CharMappings, 'CharMappings');
  initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
  initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
  initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
  //endregion
  function Default() {
    Default_instance = this;
    Json.call(this, new JsonConfiguration(), EmptySerializersModule());
  }
  var Default_instance;
  function Default_getInstance() {
    if (Default_instance == null)
      new Default();
    return Default_instance;
  }
  function Json(configuration, serializersModule) {
    Default_getInstance();
    this.r17_1 = configuration;
    this.s17_1 = serializersModule;
    this.t17_1 = new DescriptorSchemaCache();
  }
  protoOf(Json).jo = function () {
    return this.s17_1;
  };
  protoOf(Json).ho = function (serializer, value) {
    var result = new JsonToStringWriter();
    try {
      encodeByWriter(this, result, serializer, value);
      return result.toString();
    }finally {
      result.w17();
    }
  };
  protoOf(Json).io = function (deserializer, string) {
    var lexer = StringJsonLexer_0(this, string);
    var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.nn(), null);
    var result = input.sq(deserializer);
    lexer.j18();
    return result;
  };
  protoOf(Json).u17 = function (string) {
    return this.io(JsonElementSerializer_getInstance(), string);
  };
  function Json_0(from, builderAction) {
    from = from === VOID ? Default_getInstance() : from;
    var builder = new JsonBuilder(from);
    builderAction(builder);
    var conf = builder.c19();
    return new JsonImpl(conf, builder.b19_1);
  }
  function JsonBuilder(json) {
    this.k18_1 = json.r17_1.d19_1;
    this.l18_1 = json.r17_1.i19_1;
    this.m18_1 = json.r17_1.e19_1;
    this.n18_1 = json.r17_1.f19_1;
    this.o18_1 = json.r17_1.h19_1;
    this.p18_1 = json.r17_1.j19_1;
    this.q18_1 = json.r17_1.k19_1;
    this.r18_1 = json.r17_1.m19_1;
    this.s18_1 = json.r17_1.t19_1;
    this.t18_1 = json.r17_1.o19_1;
    this.u18_1 = json.r17_1.p19_1;
    this.v18_1 = json.r17_1.q19_1;
    this.w18_1 = json.r17_1.r19_1;
    this.x18_1 = json.r17_1.s19_1;
    this.y18_1 = json.r17_1.n19_1;
    this.z18_1 = json.r17_1.g19_1;
    this.a19_1 = json.r17_1.l19_1;
    this.b19_1 = json.jo();
  }
  protoOf(JsonBuilder).c19 = function () {
    if (this.a19_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.r18_1 === 'type')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message = 'Class discriminator should not be specified when array polymorphism is specified';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.s18_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
    }
    if (!this.o18_1) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this.p18_1 === '    ')) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_1 = 'Indent should not be specified when default printing mode is used';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }
    } else if (!(this.p18_1 === '    ')) {
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.text.all' call
        var indexedObject = this.p18_1;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(indexedObject)) {
          var element = charSequenceGet(indexedObject, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
          if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
            tmp$ret$4 = false;
            break $l$block;
          }
        }
        tmp$ret$4 = true;
      }
      var allWhitespaces = tmp$ret$4;
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!allWhitespaces) {
        // Inline function 'kotlinx.serialization.json.JsonBuilder.build.<anonymous>' call
        var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.p18_1;
        throw IllegalArgumentException_init_$Create$(toString(message_2));
      }
    }
    return new JsonConfiguration(this.k18_1, this.m18_1, this.n18_1, this.z18_1, this.o18_1, this.l18_1, this.p18_1, this.q18_1, this.a19_1, this.r18_1, this.y18_1, this.t18_1, this.u18_1, this.v18_1, this.w18_1, this.x18_1, this.s18_1);
  };
  function validateConfiguration($this) {
    if (equals($this.jo(), EmptySerializersModule()))
      return Unit_instance;
    var collector = new PolymorphismValidator($this.r17_1.l19_1, $this.r17_1.m19_1);
    $this.jo().z16(collector);
  }
  function JsonImpl(configuration, module_0) {
    Json.call(this, configuration, module_0);
    validateConfiguration(this);
  }
  function JsonClassDiscriminator() {
  }
  function JsonNames() {
  }
  function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
    encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
    ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
    isLenient = isLenient === VOID ? false : isLenient;
    allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
    prettyPrint = prettyPrint === VOID ? false : prettyPrint;
    explicitNulls = explicitNulls === VOID ? true : explicitNulls;
    prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
    coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
    useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
    classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
    allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
    useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
    namingStrategy = namingStrategy === VOID ? null : namingStrategy;
    decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
    allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
    allowComments = allowComments === VOID ? false : allowComments;
    classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
    this.d19_1 = encodeDefaults;
    this.e19_1 = ignoreUnknownKeys;
    this.f19_1 = isLenient;
    this.g19_1 = allowStructuredMapKeys;
    this.h19_1 = prettyPrint;
    this.i19_1 = explicitNulls;
    this.j19_1 = prettyPrintIndent;
    this.k19_1 = coerceInputValues;
    this.l19_1 = useArrayPolymorphism;
    this.m19_1 = classDiscriminator;
    this.n19_1 = allowSpecialFloatingPointValues;
    this.o19_1 = useAlternativeNames;
    this.p19_1 = namingStrategy;
    this.q19_1 = decodeEnumsCaseInsensitive;
    this.r19_1 = allowTrailingComma;
    this.s19_1 = allowComments;
    this.t19_1 = classDiscriminatorMode;
  }
  protoOf(JsonConfiguration).toString = function () {
    return 'JsonConfiguration(encodeDefaults=' + this.d19_1 + ', ignoreUnknownKeys=' + this.e19_1 + ', isLenient=' + this.f19_1 + ', ' + ('allowStructuredMapKeys=' + this.g19_1 + ', prettyPrint=' + this.h19_1 + ', explicitNulls=' + this.i19_1 + ', ') + ("prettyPrintIndent='" + this.j19_1 + "', coerceInputValues=" + this.k19_1 + ', useArrayPolymorphism=' + this.l19_1 + ', ') + ("classDiscriminator='" + this.m19_1 + "', allowSpecialFloatingPointValues=" + this.n19_1 + ', ') + ('useAlternativeNames=' + this.o19_1 + ', namingStrategy=' + toString_0(this.p19_1) + ', decodeEnumsCaseInsensitive=' + this.q19_1 + ', ') + ('allowTrailingComma=' + this.r19_1 + ', allowComments=' + this.s19_1 + ', classDiscriminatorMode=' + this.t19_1.toString() + ')');
  };
  var ClassDiscriminatorMode_NONE_instance;
  var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
  var ClassDiscriminatorMode_POLYMORPHIC_instance;
  var ClassDiscriminatorMode_entriesInitialized;
  function ClassDiscriminatorMode_initEntries() {
    if (ClassDiscriminatorMode_entriesInitialized)
      return Unit_instance;
    ClassDiscriminatorMode_entriesInitialized = true;
    ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
    ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
    ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
  }
  function ClassDiscriminatorMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClassDiscriminatorMode_NONE_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_NONE_instance;
  }
  function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
    ClassDiscriminatorMode_initEntries();
    return ClassDiscriminatorMode_POLYMORPHIC_instance;
  }
  function JsonDecoder() {
  }
  function get_jsonUnquotedLiteralDescriptor() {
    _init_properties_JsonElement_kt__7cbdc2();
    return jsonUnquotedLiteralDescriptor;
  }
  var jsonUnquotedLiteralDescriptor;
  function Companion() {
  }
  protoOf(Companion).w19 = function () {
    return JsonElementSerializer_getInstance();
  };
  var Companion_instance;
  function Companion_getInstance_3() {
    return Companion_instance;
  }
  function JsonElement() {
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_4() {
    return Companion_instance_0;
  }
  function JsonObject$toString$lambda(_destruct__k2r9zo) {
    // Inline function 'kotlin.collections.component1' call
    var k = _destruct__k2r9zo.v();
    // Inline function 'kotlin.collections.component2' call
    var v = _destruct__k2r9zo.w();
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.JsonObject.toString.<anonymous>.<anonymous>' call
    printQuoted(this_0, k);
    this_0.j8(_Char___init__impl__6a9atx(58));
    this_0.h8(v);
    return this_0.toString();
  }
  function JsonObject(content) {
    JsonElement.call(this);
    this.x19_1 = content;
  }
  protoOf(JsonObject).equals = function (other) {
    return equals(this.x19_1, other);
  };
  protoOf(JsonObject).hashCode = function () {
    return hashCode(this.x19_1);
  };
  protoOf(JsonObject).toString = function () {
    var tmp = this.x19_1.u();
    return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
  };
  protoOf(JsonObject).y19 = function (key) {
    return this.x19_1.z1(key);
  };
  protoOf(JsonObject).z1 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.y19((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).de = function (key) {
    return this.x19_1.b2(key);
  };
  protoOf(JsonObject).b2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.de((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(JsonObject).k = function () {
    return this.x19_1.k();
  };
  protoOf(JsonObject).u = function () {
    return this.x19_1.u();
  };
  protoOf(JsonObject).c2 = function () {
    return this.x19_1.c2();
  };
  protoOf(JsonObject).j = function () {
    return this.x19_1.j();
  };
  protoOf(JsonObject).d2 = function () {
    return this.x19_1.d2();
  };
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function JsonPrimitive() {
    JsonElement.call(this);
  }
  protoOf(JsonPrimitive).toString = function () {
    return this.z19();
  };
  function JsonPrimitive_0(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, true);
  }
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function JsonArray(content) {
    JsonElement.call(this);
    this.a1a_1 = content;
  }
  protoOf(JsonArray).equals = function (other) {
    return equals(this.a1a_1, other);
  };
  protoOf(JsonArray).hashCode = function () {
    return hashCode(this.a1a_1);
  };
  protoOf(JsonArray).toString = function () {
    return joinToString(this.a1a_1, ',', '[', ']');
  };
  protoOf(JsonArray).b1a = function (element) {
    return this.a1a_1.r(element);
  };
  protoOf(JsonArray).r = function (element) {
    if (!(element instanceof JsonElement))
      return false;
    return this.b1a(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).c1a = function (elements) {
    return this.a1a_1.x1(elements);
  };
  protoOf(JsonArray).x1 = function (elements) {
    return this.c1a(elements);
  };
  protoOf(JsonArray).l = function (index) {
    return this.a1a_1.l(index);
  };
  protoOf(JsonArray).d1a = function (element) {
    return this.a1a_1.s(element);
  };
  protoOf(JsonArray).s = function (element) {
    if (!(element instanceof JsonElement))
      return -1;
    return this.d1a(element instanceof JsonElement ? element : THROW_CCE());
  };
  protoOf(JsonArray).k = function () {
    return this.a1a_1.k();
  };
  protoOf(JsonArray).g = function () {
    return this.a1a_1.g();
  };
  protoOf(JsonArray).q = function (index) {
    return this.a1a_1.q(index);
  };
  protoOf(JsonArray).y1 = function (fromIndex, toIndex) {
    return this.a1a_1.y1(fromIndex, toIndex);
  };
  protoOf(JsonArray).j = function () {
    return this.a1a_1.j();
  };
  function JsonPrimitive_1(value) {
    _init_properties_JsonElement_kt__7cbdc2();
    if (value == null)
      return JsonNull_getInstance();
    return new JsonLiteral(value, false);
  }
  function JsonNull() {
    JsonNull_instance = this;
    JsonPrimitive.call(this);
    this.e1a_1 = 'null';
  }
  protoOf(JsonNull).z19 = function () {
    return this.e1a_1;
  };
  protoOf(JsonNull).w19 = function () {
    return JsonNullSerializer_getInstance();
  };
  protoOf(JsonNull).gz = function (typeParamsSerializers) {
    return this.w19();
  };
  var JsonNull_instance;
  function JsonNull_getInstance() {
    if (JsonNull_instance == null)
      new JsonNull();
    return JsonNull_instance;
  }
  function JsonLiteral(body, isString, coerceToInlineType) {
    coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
    JsonPrimitive.call(this);
    this.f1a_1 = isString;
    this.g1a_1 = coerceToInlineType;
    this.h1a_1 = toString(body);
    if (!(this.g1a_1 == null)) {
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!this.g1a_1.yo()) {
        // Inline function 'kotlin.require.<anonymous>' call
        var message = 'Failed requirement.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  protoOf(JsonLiteral).z19 = function () {
    return this.h1a_1;
  };
  protoOf(JsonLiteral).toString = function () {
    var tmp;
    if (this.f1a_1) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.JsonLiteral.toString.<anonymous>' call
      printQuoted(this_0, this.h1a_1);
      tmp = this_0.toString();
    } else {
      tmp = this.h1a_1;
    }
    return tmp;
  };
  protoOf(JsonLiteral).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof JsonLiteral))
      THROW_CCE();
    if (!(this.f1a_1 === other.f1a_1))
      return false;
    if (!(this.h1a_1 === other.h1a_1))
      return false;
    return true;
  };
  protoOf(JsonLiteral).hashCode = function () {
    var result = getBooleanHashCode(this.f1a_1);
    result = imul(31, result) + getStringHashCode(this.h1a_1) | 0;
    return result;
  };
  function get_booleanOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toBooleanStrictOrNull_0(_this__u8e3s4.z19());
  }
  function get_int(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlinx.serialization.json.mapExceptions' call
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.<get-int>.<anonymous>' call
      tmp = (new StringJsonLexer(_this__u8e3s4.z19())).i1a();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof JsonDecodingException) {
        var e = $p;
        throw NumberFormatException_init_$Create$(e.message);
      } else {
        throw $p;
      }
    }
    var result = tmp;
    // Inline function 'kotlin.ranges.contains' call
    var this_0 = numberRangeToNumber(-2147483648, 2147483647);
    if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
      throw NumberFormatException_init_$Create$(_this__u8e3s4.z19() + ' is not an Int');
    return result.g1();
  }
  function get_long(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlinx.serialization.json.mapExceptions' call
    var tmp;
    try {
      // Inline function 'kotlinx.serialization.json.<get-long>.<anonymous>' call
      tmp = (new StringJsonLexer(_this__u8e3s4.z19())).i1a();
    } catch ($p) {
      var tmp_0;
      if ($p instanceof JsonDecodingException) {
        var e = $p;
        throw NumberFormatException_init_$Create$(e.message);
      } else {
        throw $p;
      }
    }
    return tmp;
  }
  function get_float(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    // Inline function 'kotlin.text.toFloat' call
    var this_0 = _this__u8e3s4.z19();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return toDouble(this_0);
  }
  function get_double(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    return toDouble(_this__u8e3s4.z19());
  }
  function get_contentOrNull(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp;
    if (_this__u8e3s4 instanceof JsonNull) {
      tmp = null;
    } else {
      tmp = _this__u8e3s4.z19();
    }
    return tmp;
  }
  function get_jsonPrimitive(_this__u8e3s4) {
    _init_properties_JsonElement_kt__7cbdc2();
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      error(_this__u8e3s4, 'JsonPrimitive');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function error(_this__u8e3s4, element) {
    _init_properties_JsonElement_kt__7cbdc2();
    throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
  }
  var properties_initialized_JsonElement_kt_abxy8s;
  function _init_properties_JsonElement_kt__7cbdc2() {
    if (!properties_initialized_JsonElement_kt_abxy8s) {
      properties_initialized_JsonElement_kt_abxy8s = true;
      jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
    }
  }
  function JsonObjectBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.linkedMapOf' call
    tmp.j1a_1 = LinkedHashMap_init_$Create$();
  }
  protoOf(JsonObjectBuilder).k1a = function (key, element) {
    return this.j1a_1.k2(key, element);
  };
  protoOf(JsonObjectBuilder).c19 = function () {
    return new JsonObject(this.j1a_1);
  };
  function put(_this__u8e3s4, key, value) {
    return _this__u8e3s4.k1a(key, JsonPrimitive_0(value));
  }
  function put_0(_this__u8e3s4, key, value) {
    return _this__u8e3s4.k1a(key, JsonPrimitive_1(value));
  }
  function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.yn('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
    $this$buildSerialDescriptor.yn('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
    $this$buildSerialDescriptor.yn('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
    $this$buildSerialDescriptor.yn('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
    $this$buildSerialDescriptor.yn('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
    return Unit_instance;
  }
  function JsonElementSerializer$descriptor$lambda$lambda() {
    return JsonPrimitiveSerializer_getInstance().l1a_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_0() {
    return JsonNullSerializer_getInstance().m1a_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_1() {
    return JsonLiteralSerializer_getInstance().n1a_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_2() {
    return JsonObjectSerializer_getInstance().o1a_1;
  }
  function JsonElementSerializer$descriptor$lambda$lambda_3() {
    return JsonArraySerializer_getInstance().p1a_1;
  }
  function JsonElementSerializer() {
    JsonElementSerializer_instance = this;
    var tmp = this;
    var tmp_0 = SEALED_getInstance();
    tmp.q1a_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
  }
  protoOf(JsonElementSerializer).nn = function () {
    return this.q1a_1;
  };
  protoOf(JsonElementSerializer).r1a = function (encoder, value) {
    verify(encoder);
    if (value instanceof JsonPrimitive) {
      encoder.ks(JsonPrimitiveSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonObject) {
        encoder.ks(JsonObjectSerializer_getInstance(), value);
      } else {
        if (value instanceof JsonArray) {
          encoder.ks(JsonArraySerializer_getInstance(), value);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  };
  protoOf(JsonElementSerializer).on = function (encoder, value) {
    return this.r1a(encoder, value instanceof JsonElement ? value : THROW_CCE());
  };
  protoOf(JsonElementSerializer).pn = function (decoder) {
    var input = asJsonDecoder(decoder);
    return input.v19();
  };
  var JsonElementSerializer_instance;
  function JsonElementSerializer_getInstance() {
    if (JsonElementSerializer_instance == null)
      new JsonElementSerializer();
    return JsonElementSerializer_instance;
  }
  function JsonObjectDescriptor() {
    JsonObjectDescriptor_instance = this;
    this.s1a_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).nn();
    this.t1a_1 = 'kotlinx.serialization.json.JsonObject';
  }
  protoOf(JsonObjectDescriptor).wo = function () {
    return this.t1a_1;
  };
  protoOf(JsonObjectDescriptor).bp = function (index) {
    return this.s1a_1.bp(index);
  };
  protoOf(JsonObjectDescriptor).cp = function (name) {
    return this.s1a_1.cp(name);
  };
  protoOf(JsonObjectDescriptor).dp = function (index) {
    return this.s1a_1.dp(index);
  };
  protoOf(JsonObjectDescriptor).ep = function (index) {
    return this.s1a_1.ep(index);
  };
  protoOf(JsonObjectDescriptor).fp = function (index) {
    return this.s1a_1.fp(index);
  };
  protoOf(JsonObjectDescriptor).xo = function () {
    return this.s1a_1.xo();
  };
  protoOf(JsonObjectDescriptor).so = function () {
    return this.s1a_1.so();
  };
  protoOf(JsonObjectDescriptor).yo = function () {
    return this.s1a_1.yo();
  };
  protoOf(JsonObjectDescriptor).zo = function () {
    return this.s1a_1.zo();
  };
  protoOf(JsonObjectDescriptor).ap = function () {
    return this.s1a_1.ap();
  };
  var JsonObjectDescriptor_instance;
  function JsonObjectDescriptor_getInstance() {
    if (JsonObjectDescriptor_instance == null)
      new JsonObjectDescriptor();
    return JsonObjectDescriptor_instance;
  }
  function JsonObjectSerializer() {
    JsonObjectSerializer_instance = this;
    this.o1a_1 = JsonObjectDescriptor_getInstance();
  }
  protoOf(JsonObjectSerializer).nn = function () {
    return this.o1a_1;
  };
  protoOf(JsonObjectSerializer).u1a = function (encoder, value) {
    verify(encoder);
    MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).on(encoder, value);
  };
  protoOf(JsonObjectSerializer).on = function (encoder, value) {
    return this.u1a(encoder, value instanceof JsonObject ? value : THROW_CCE());
  };
  protoOf(JsonObjectSerializer).pn = function (decoder) {
    verify_0(decoder);
    return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).pn(decoder));
  };
  var JsonObjectSerializer_instance;
  function JsonObjectSerializer_getInstance() {
    if (JsonObjectSerializer_instance == null)
      new JsonObjectSerializer();
    return JsonObjectSerializer_instance;
  }
  function JsonPrimitiveSerializer() {
    JsonPrimitiveSerializer_instance = this;
    this.l1a_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
  }
  protoOf(JsonPrimitiveSerializer).nn = function () {
    return this.l1a_1;
  };
  protoOf(JsonPrimitiveSerializer).v1a = function (encoder, value) {
    verify(encoder);
    var tmp;
    if (value instanceof JsonNull) {
      encoder.ks(JsonNullSerializer_getInstance(), JsonNull_getInstance());
      tmp = Unit_instance;
    } else {
      var tmp_0 = JsonLiteralSerializer_getInstance();
      encoder.ks(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(JsonPrimitiveSerializer).on = function (encoder, value) {
    return this.v1a(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
  };
  protoOf(JsonPrimitiveSerializer).pn = function (decoder) {
    var result = asJsonDecoder(decoder).v19();
    if (!(result instanceof JsonPrimitive))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonPrimitiveSerializer_instance;
  function JsonPrimitiveSerializer_getInstance() {
    if (JsonPrimitiveSerializer_instance == null)
      new JsonPrimitiveSerializer();
    return JsonPrimitiveSerializer_instance;
  }
  function JsonArrayDescriptor() {
    JsonArrayDescriptor_instance = this;
    this.w1a_1 = ListSerializer(JsonElementSerializer_getInstance()).nn();
    this.x1a_1 = 'kotlinx.serialization.json.JsonArray';
  }
  protoOf(JsonArrayDescriptor).wo = function () {
    return this.x1a_1;
  };
  protoOf(JsonArrayDescriptor).bp = function (index) {
    return this.w1a_1.bp(index);
  };
  protoOf(JsonArrayDescriptor).cp = function (name) {
    return this.w1a_1.cp(name);
  };
  protoOf(JsonArrayDescriptor).dp = function (index) {
    return this.w1a_1.dp(index);
  };
  protoOf(JsonArrayDescriptor).ep = function (index) {
    return this.w1a_1.ep(index);
  };
  protoOf(JsonArrayDescriptor).fp = function (index) {
    return this.w1a_1.fp(index);
  };
  protoOf(JsonArrayDescriptor).xo = function () {
    return this.w1a_1.xo();
  };
  protoOf(JsonArrayDescriptor).so = function () {
    return this.w1a_1.so();
  };
  protoOf(JsonArrayDescriptor).yo = function () {
    return this.w1a_1.yo();
  };
  protoOf(JsonArrayDescriptor).zo = function () {
    return this.w1a_1.zo();
  };
  protoOf(JsonArrayDescriptor).ap = function () {
    return this.w1a_1.ap();
  };
  var JsonArrayDescriptor_instance;
  function JsonArrayDescriptor_getInstance() {
    if (JsonArrayDescriptor_instance == null)
      new JsonArrayDescriptor();
    return JsonArrayDescriptor_instance;
  }
  function JsonArraySerializer() {
    JsonArraySerializer_instance = this;
    this.p1a_1 = JsonArrayDescriptor_getInstance();
  }
  protoOf(JsonArraySerializer).nn = function () {
    return this.p1a_1;
  };
  protoOf(JsonArraySerializer).y1a = function (encoder, value) {
    verify(encoder);
    ListSerializer(JsonElementSerializer_getInstance()).on(encoder, value);
  };
  protoOf(JsonArraySerializer).on = function (encoder, value) {
    return this.y1a(encoder, value instanceof JsonArray ? value : THROW_CCE());
  };
  protoOf(JsonArraySerializer).pn = function (decoder) {
    verify_0(decoder);
    return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).pn(decoder));
  };
  var JsonArraySerializer_instance;
  function JsonArraySerializer_getInstance() {
    if (JsonArraySerializer_instance == null)
      new JsonArraySerializer();
    return JsonArraySerializer_instance;
  }
  function JsonNullSerializer() {
    JsonNullSerializer_instance = this;
    this.m1a_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
  }
  protoOf(JsonNullSerializer).nn = function () {
    return this.m1a_1;
  };
  protoOf(JsonNullSerializer).z1a = function (encoder, value) {
    verify(encoder);
    encoder.nr();
  };
  protoOf(JsonNullSerializer).on = function (encoder, value) {
    return this.z1a(encoder, value instanceof JsonNull ? value : THROW_CCE());
  };
  protoOf(JsonNullSerializer).pn = function (decoder) {
    verify_0(decoder);
    if (decoder.eq()) {
      throw new JsonDecodingException("Expected 'null' literal");
    }
    decoder.fq();
    return JsonNull_getInstance();
  };
  var JsonNullSerializer_instance;
  function JsonNullSerializer_getInstance() {
    if (JsonNullSerializer_instance == null)
      new JsonNullSerializer();
    return JsonNullSerializer_instance;
  }
  function defer(deferred) {
    return new defer$1(deferred);
  }
  function JsonLiteralSerializer() {
    JsonLiteralSerializer_instance = this;
    this.n1a_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
  }
  protoOf(JsonLiteralSerializer).nn = function () {
    return this.n1a_1;
  };
  protoOf(JsonLiteralSerializer).a1b = function (encoder, value) {
    verify(encoder);
    if (value.f1a_1) {
      return encoder.wr(value.h1a_1);
    }
    if (!(value.g1a_1 == null)) {
      return encoder.yr(value.g1a_1).wr(value.h1a_1);
    }
    var tmp0_safe_receiver = toLongOrNull(value.h1a_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.sr(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = toULongOrNull(value.h1a_1);
    var tmp = tmp1_safe_receiver;
    if ((tmp == null ? null : new ULong(tmp)) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = tmp1_safe_receiver;
      // Inline function 'kotlin.contracts.contract' call
      var it = (tmp_0 == null ? null : new ULong(tmp_0)).tm_1;
      var tmp_1 = encoder.yr(serializer_0(Companion_getInstance()).nn());
      // Inline function 'kotlin.ULong.toLong' call
      var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
      tmp_1.sr(tmp$ret$1);
      return Unit_instance;
    }
    var tmp2_safe_receiver = toDoubleOrNull(value.h1a_1);
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.ur(tmp2_safe_receiver);
    }
    var tmp3_safe_receiver = toBooleanStrictOrNull(value.h1a_1);
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return encoder.or(tmp3_safe_receiver);
    }
    encoder.wr(value.h1a_1);
  };
  protoOf(JsonLiteralSerializer).on = function (encoder, value) {
    return this.a1b(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
  };
  protoOf(JsonLiteralSerializer).pn = function (decoder) {
    var result = asJsonDecoder(decoder).v19();
    if (!(result instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
    return result;
  };
  var JsonLiteralSerializer_instance;
  function JsonLiteralSerializer_getInstance() {
    if (JsonLiteralSerializer_instance == null)
      new JsonLiteralSerializer();
    return JsonLiteralSerializer_instance;
  }
  function verify(encoder) {
    asJsonEncoder(encoder);
  }
  function asJsonDecoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function verify_0(decoder) {
    asJsonDecoder(decoder);
  }
  function asJsonEncoder(_this__u8e3s4) {
    var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function _get_original__l7ku1m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b1b_1;
    original$factory();
    return this_0.w();
  }
  function defer$1($deferred) {
    this.b1b_1 = lazy($deferred);
  }
  protoOf(defer$1).wo = function () {
    return _get_original__l7ku1m(this).wo();
  };
  protoOf(defer$1).xo = function () {
    return _get_original__l7ku1m(this).xo();
  };
  protoOf(defer$1).zo = function () {
    return _get_original__l7ku1m(this).zo();
  };
  protoOf(defer$1).bp = function (index) {
    return _get_original__l7ku1m(this).bp(index);
  };
  protoOf(defer$1).cp = function (name) {
    return _get_original__l7ku1m(this).cp(name);
  };
  protoOf(defer$1).dp = function (index) {
    return _get_original__l7ku1m(this).dp(index);
  };
  protoOf(defer$1).ep = function (index) {
    return _get_original__l7ku1m(this).ep(index);
  };
  protoOf(defer$1).fp = function (index) {
    return _get_original__l7ku1m(this).fp(index);
  };
  function original$factory() {
    return getPropertyCallableRef('original', 1, KProperty1, function (receiver) {
      return _get_original__l7ku1m(receiver);
    }, null);
  }
  function JsonEncoder() {
  }
  function Composer(writer) {
    this.c1b_1 = writer;
    this.d1b_1 = true;
  }
  protoOf(Composer).e1b = function () {
    this.d1b_1 = true;
  };
  protoOf(Composer).f1b = function () {
    return Unit_instance;
  };
  protoOf(Composer).g1b = function () {
    this.d1b_1 = false;
  };
  protoOf(Composer).h1b = function () {
    this.d1b_1 = false;
  };
  protoOf(Composer).i1b = function () {
    return Unit_instance;
  };
  protoOf(Composer).j1b = function (v) {
    return this.c1b_1.k1b(v);
  };
  protoOf(Composer).l1b = function (v) {
    return this.c1b_1.m1b(v);
  };
  protoOf(Composer).n1b = function (v) {
    return this.c1b_1.m1b(v.toString());
  };
  protoOf(Composer).o1b = function (v) {
    return this.c1b_1.m1b(v.toString());
  };
  protoOf(Composer).p1b = function (v) {
    return this.c1b_1.q1b(toLong(v));
  };
  protoOf(Composer).r1b = function (v) {
    return this.c1b_1.q1b(toLong(v));
  };
  protoOf(Composer).s1b = function (v) {
    return this.c1b_1.q1b(toLong(v));
  };
  protoOf(Composer).t1b = function (v) {
    return this.c1b_1.q1b(v);
  };
  protoOf(Composer).u1b = function (v) {
    return this.c1b_1.m1b(v.toString());
  };
  protoOf(Composer).v1b = function (value) {
    return this.c1b_1.w1b(value);
  };
  function Composer_0(sb, json) {
    return json.r17_1.h19_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
  }
  function ComposerForUnsignedNumbers(writer, forceQuoting) {
    Composer.call(this, writer);
    this.z1b_1 = forceQuoting;
  }
  protoOf(ComposerForUnsignedNumbers).s1b = function (v) {
    if (this.z1b_1) {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
      this.v1b(UInt__toString_impl_dbgl21(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUInt' call
      var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
      this.l1b(UInt__toString_impl_dbgl21(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).t1b = function (v) {
    if (this.z1b_1) {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
      this.v1b(ULong__toString_impl_f9au7k(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toULong' call
      var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
      this.l1b(ULong__toString_impl_f9au7k(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).p1b = function (v) {
    if (this.z1b_1) {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
      this.v1b(UByte__toString_impl_v72jg(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUByte' call
      var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
      this.l1b(UByte__toString_impl_v72jg(tmp$ret$1));
    }
  };
  protoOf(ComposerForUnsignedNumbers).r1b = function (v) {
    if (this.z1b_1) {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$0 = _UShort___init__impl__jigrne(v);
      this.v1b(UShort__toString_impl_edaoee(tmp$ret$0));
    } else {
      // Inline function 'kotlin.toUShort' call
      var tmp$ret$1 = _UShort___init__impl__jigrne(v);
      this.l1b(UShort__toString_impl_edaoee(tmp$ret$1));
    }
  };
  function ComposerForUnquotedLiterals(writer, forceQuoting) {
    Composer.call(this, writer);
    this.c1c_1 = forceQuoting;
  }
  protoOf(ComposerForUnquotedLiterals).v1b = function (value) {
    if (this.c1c_1) {
      protoOf(Composer).v1b.call(this, value);
    } else {
      protoOf(Composer).l1b.call(this, value);
    }
  };
  function ComposerWithPrettyPrint(writer, json) {
    Composer.call(this, writer);
    this.f1c_1 = json;
    this.g1c_1 = 0;
  }
  protoOf(ComposerWithPrettyPrint).e1b = function () {
    this.d1b_1 = true;
    this.g1c_1 = this.g1c_1 + 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).f1b = function () {
    this.g1c_1 = this.g1c_1 - 1 | 0;
  };
  protoOf(ComposerWithPrettyPrint).g1b = function () {
    this.d1b_1 = false;
    this.l1b('\n');
    // Inline function 'kotlin.repeat' call
    var times = this.g1c_1;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.ComposerWithPrettyPrint.nextItem.<anonymous>' call
        this.l1b(this.f1c_1.r17_1.j19_1);
      }
       while (inductionVariable < times);
  };
  protoOf(ComposerWithPrettyPrint).h1b = function () {
    if (this.d1b_1)
      this.d1b_1 = false;
    else {
      this.g1b();
    }
  };
  protoOf(ComposerWithPrettyPrint).i1b = function () {
    this.j1b(_Char___init__impl__6a9atx(32));
  };
  function readIfAbsent($this, descriptor, index) {
    $this.i1c_1 = (!descriptor.fp(index) && descriptor.ep(index).so());
    return $this.i1c_1;
  }
  function JsonElementMarker$readIfAbsent$ref($boundThis) {
    var l = function (p0, p1) {
      return readIfAbsent($boundThis, p0, p1);
    };
    l.callableName = 'readIfAbsent';
    return l;
  }
  function JsonElementMarker(descriptor) {
    var tmp = this;
    tmp.h1c_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
    this.i1c_1 = false;
  }
  protoOf(JsonElementMarker).j1c = function (index) {
    this.h1c_1.yw(index);
  };
  protoOf(JsonElementMarker).k1c = function () {
    return this.h1c_1.zw();
  };
  function invalidTrailingComma(_this__u8e3s4, entity) {
    entity = entity === VOID ? 'object' : entity;
    _this__u8e3s4.l1c('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.f18_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingCommas = true' in 'Json {}' builder to support them.");
  }
  function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
    _this__u8e3s4.m1c('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
  }
  function JsonEncodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonEncodingException);
  }
  function InvalidKeyKindException(keyDescriptor) {
    return new JsonEncodingException("Value of type '" + keyDescriptor.wo() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.xo().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
  }
  function JsonDecodingException(message) {
    JsonException.call(this, message);
    captureStack(this, JsonDecodingException);
  }
  function JsonDecodingException_0(offset, message, input) {
    return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
  }
  function InvalidFloatingPointDecoded(value, key, output) {
    return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
  }
  function UnknownKeyException(key, input) {
    return JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "'.\n" + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.\n" + ('Current input: ' + toString(minify(input))));
  }
  function InvalidFloatingPointEncoded(value, output) {
    return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
  }
  function JsonException(message) {
    SerializationException_init_$Init$(message, this);
    captureStack(this, JsonException);
  }
  function unexpectedFpErrorMessage(value, key, output) {
    return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification. ' + "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
  }
  function JsonDecodingException_1(offset, message) {
    return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
  }
  function minify(_this__u8e3s4, offset) {
    offset = offset === VOID ? -1 : offset;
    if (charSequenceLength(_this__u8e3s4) < 200)
      return _this__u8e3s4;
    if (offset === -1) {
      var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
      if (start <= 0)
        return _this__u8e3s4;
      // Inline function 'kotlin.text.substring' call
      var endIndex = charSequenceLength(_this__u8e3s4);
      return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
    }
    var start_0 = offset - 30 | 0;
    var end = offset + 30 | 0;
    var prefix = start_0 <= 0 ? '' : '.....';
    var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
    // Inline function 'kotlin.text.substring' call
    var startIndex = coerceAtLeast(start_0, 0);
    var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
    return prefix + toString(charSequenceSubSequence(_this__u8e3s4, startIndex, endIndex_0)) + suffix;
  }
  function get_JsonDeserializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonDeserializationNamesKey;
  }
  var JsonDeserializationNamesKey;
  function get_JsonSerializationNamesKey() {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return JsonSerializationNamesKey;
  }
  var JsonSerializationNamesKey;
  function getJsonNameIndex(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    if (decodeCaseInsensitive(json, _this__u8e3s4)) {
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$1 = name.toLowerCase();
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
    }
    var strategy = namingStrategy(_this__u8e3s4, json);
    if (!(strategy == null))
      return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
    var index = _this__u8e3s4.cp(name);
    if (!(index === -3))
      return index;
    if (!json.r17_1.o19_1)
      return index;
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  }
  function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
    suffix = suffix === VOID ? '' : suffix;
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var index = getJsonNameIndex(_this__u8e3s4, json, name);
    if (index === -3)
      throw SerializationException_init_$Create$(_this__u8e3s4.wo() + " does not contain element with name '" + name + "'" + suffix);
    return index;
  }
  function getJsonElementName(_this__u8e3s4, json, index) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var strategy = namingStrategy(_this__u8e3s4, json);
    return strategy == null ? _this__u8e3s4.bp(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
  }
  function namingStrategy(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return equals(_this__u8e3s4.xo(), CLASS_getInstance()) ? json.r17_1.p19_1 : null;
  }
  function deserializationNamesMap(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(_this__u8e3s4);
    var tmp_0 = get_JsonDeserializationNamesKey();
    return tmp.o1c(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
  }
  function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    return _this__u8e3s4.r17_1.q19_1 && equals(descriptor.xo(), ENUM_getInstance());
  }
  function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).b2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  }
  function serializationNamesIndices(_this__u8e3s4, json, strategy) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    var tmp = get_schemaCache(json);
    var tmp_0 = get_JsonSerializationNamesKey();
    return tmp.o1c(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
  }
  function buildDeserializationNamesMap(_this__u8e3s4, json) {
    _init_properties_JsonNamesMap_kt__cbbp0k();
    // Inline function 'kotlin.collections.mutableMapOf' call
    var builder = LinkedHashMap_init_$Create$();
    var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
    var strategyForClasses = namingStrategy(_this__u8e3s4, json);
    var inductionVariable = 0;
    var last = _this__u8e3s4.zo();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.filterIsInstance' call
        // Inline function 'kotlin.collections.filterIsInstanceTo' call
        var this_0 = _this__u8e3s4.dp(i);
        var destination = ArrayList_init_$Create$();
        var tmp0_iterator = this_0.g();
        while (tmp0_iterator.h()) {
          var element = tmp0_iterator.i();
          if (element instanceof JsonNames) {
            destination.e(element);
          }
        }
        var tmp0_safe_receiver = singleOrNull(destination);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p1c_1;
        if (tmp1_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.collections.forEach' call
          var inductionVariable_0 = 0;
          var last_0 = tmp1_safe_receiver.length;
          while (inductionVariable_0 < last_0) {
            var element_0 = tmp1_safe_receiver[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
            var tmp;
            if (useLowercaseEnums) {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp = element_0.toLowerCase();
            } else {
              tmp = element_0;
            }
            buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
          }
        }
        var tmp_0;
        if (useLowercaseEnums) {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_0 = _this__u8e3s4.bp(i).toLowerCase();
        } else if (!(strategyForClasses == null)) {
          tmp_0 = strategyForClasses.q1c(_this__u8e3s4, i, _this__u8e3s4.bp(i));
        } else {
          tmp_0 = null;
        }
        var nameToPut = tmp_0;
        if (nameToPut == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
        }
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_1;
    if (builder.k()) {
      // Inline function 'kotlinx.serialization.json.internal.buildDeserializationNamesMap.<anonymous>' call
      tmp_1 = emptyMap();
    } else {
      tmp_1 = builder;
    }
    return tmp_1;
  }
  function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
    var entity = equals($this_buildDeserializationNamesMap.xo(), ENUM_getInstance()) ? 'enum value' : 'property';
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).z1(name)) {
      throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.bp(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.bp(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
    }
    // Inline function 'kotlin.collections.set' call
    _this__u8e3s4.k2(name, index);
  }
  function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
    return function () {
      return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
    };
  }
  function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
    return function () {
      var tmp = 0;
      var tmp_0 = $this_serializationNamesIndices.zo();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        var baseName = $this_serializationNamesIndices.bp(tmp_2);
        tmp_1[tmp_2] = $strategy.q1c($this_serializationNamesIndices, tmp_2, baseName);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  var properties_initialized_JsonNamesMap_kt_ljpf42;
  function _init_properties_JsonNamesMap_kt__cbbp0k() {
    if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
      properties_initialized_JsonNamesMap_kt_ljpf42 = true;
      JsonDeserializationNamesKey = new Key();
      JsonSerializationNamesKey = new Key();
    }
  }
  function Tombstone() {
  }
  var Tombstone_instance;
  function Tombstone_getInstance() {
    return Tombstone_instance;
  }
  function resize($this) {
    var newSize = imul($this.t1c_1, 2);
    $this.r1c_1 = copyOf($this.r1c_1, newSize);
    $this.s1c_1 = copyOf_0($this.s1c_1, newSize);
  }
  function JsonPath() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.r1c_1 = fillArrayVal(Array(8), null);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(8);
    while (tmp_1 < 8) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.s1c_1 = tmp_2;
    this.t1c_1 = -1;
  }
  protoOf(JsonPath).u1c = function (sd) {
    this.t1c_1 = this.t1c_1 + 1 | 0;
    var depth = this.t1c_1;
    if (depth === this.r1c_1.length) {
      resize(this);
    }
    this.r1c_1[depth] = sd;
  };
  protoOf(JsonPath).v1c = function (index) {
    this.s1c_1[this.t1c_1] = index;
  };
  protoOf(JsonPath).w1c = function (key) {
    var tmp;
    if (!(this.s1c_1[this.t1c_1] === -2)) {
      this.t1c_1 = this.t1c_1 + 1 | 0;
      tmp = this.t1c_1 === this.r1c_1.length;
    } else {
      tmp = false;
    }
    if (tmp) {
      resize(this);
    }
    this.r1c_1[this.t1c_1] = key;
    this.s1c_1[this.t1c_1] = -2;
  };
  protoOf(JsonPath).x1c = function () {
    if (this.s1c_1[this.t1c_1] === -2) {
      this.r1c_1[this.t1c_1] = Tombstone_instance;
    }
  };
  protoOf(JsonPath).y1c = function () {
    var depth = this.t1c_1;
    if (this.s1c_1[depth] === -2) {
      this.s1c_1[depth] = -1;
      this.t1c_1 = this.t1c_1 - 1 | 0;
    }
    if (!(this.t1c_1 === -1)) {
      this.t1c_1 = this.t1c_1 - 1 | 0;
    }
  };
  protoOf(JsonPath).z1c = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>' call
    this_0.i8('$');
    // Inline function 'kotlin.repeat' call
    var times = this.t1c_1 + 1 | 0;
    // Inline function 'kotlin.contracts.contract' call
    var inductionVariable = 0;
    if (inductionVariable < times)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.json.internal.JsonPath.getPath.<anonymous>.<anonymous>' call
        var element = this.r1c_1[index];
        if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
          if (equals(element.xo(), LIST_getInstance())) {
            if (!(this.s1c_1[index] === -1)) {
              this_0.i8('[');
              this_0.vc(this.s1c_1[index]);
              this_0.i8(']');
            }
          } else {
            var idx = this.s1c_1[index];
            if (idx >= 0) {
              this_0.i8('.');
              this_0.i8(element.bp(idx));
            }
          }
        } else {
          if (!(element === Tombstone_instance)) {
            this_0.i8('[');
            this_0.i8("'");
            this_0.h8(element);
            this_0.i8("'");
            this_0.i8(']');
          }
        }
      }
       while (inductionVariable < times);
    return this_0.toString();
  };
  protoOf(JsonPath).toString = function () {
    return this.z1c();
  };
  function encodeByWriter(json, writer, serializer, value) {
    var tmp = WriteMode_OBJ_getInstance();
    // Inline function 'kotlin.arrayOfNulls' call
    var size = get_entries().j();
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
    encoder.ks(serializer, value);
  }
  function readObject($this) {
    // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
    var lastToken = $this.j1d_1.n1d(6);
    if ($this.j1d_1.o1d() === 4) {
      $this.j1d_1.m1c('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.linkedMapOf' call
    var result = LinkedHashMap_init_$Create$();
    $l$loop: while ($this.j1d_1.p1d()) {
      var key = $this.k1d_1 ? $this.j1d_1.r1d() : $this.j1d_1.q1d();
      $this.j1d_1.n1d(5);
      // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObject.<anonymous>' call
      var element = $this.s1d();
      // Inline function 'kotlin.collections.set' call
      result.k2(key, element);
      lastToken = $this.j1d_1.t1d();
      var tmp0_subject = lastToken;
      if (tmp0_subject !== 4)
        if (tmp0_subject === 7)
          break $l$loop;
        else {
          $this.j1d_1.m1c('Expected end of the object or comma');
        }
    }
    if (lastToken === 6) {
      $this.j1d_1.n1d(7);
    } else if (lastToken === 4) {
      if (!$this.l1d_1) {
        invalidTrailingComma($this.j1d_1);
      }
      $this.j1d_1.n1d(7);
    }
    return new JsonObject(result);
  }
  function readObject_0(_this__u8e3s4, $this, $completion) {
    var tmp = new $readObjectCOROUTINE$0($this, _this__u8e3s4, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function readArray($this) {
    var lastToken = $this.j1d_1.t1d();
    if ($this.j1d_1.o1d() === 4) {
      $this.j1d_1.m1c('Unexpected leading comma');
    }
    // Inline function 'kotlin.collections.arrayListOf' call
    var result = ArrayList_init_$Create$();
    while ($this.j1d_1.p1d()) {
      var element = $this.s1d();
      result.e(element);
      lastToken = $this.j1d_1.t1d();
      if (!(lastToken === 4)) {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var this_0 = $this.j1d_1;
        var condition = lastToken === 9;
        var position = this_0.f18_1;
        if (!condition) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readArray.<anonymous>' call
          var tmp$ret$1 = 'Expected end of the array or comma';
          this_0.m1c(tmp$ret$1, position);
        }
      }
    }
    if (lastToken === 8) {
      $this.j1d_1.n1d(9);
    } else if (lastToken === 4) {
      if (!$this.l1d_1) {
        invalidTrailingComma($this.j1d_1, 'array');
      }
      $this.j1d_1.n1d(9);
    }
    return new JsonArray(result);
  }
  function readValue($this, isString) {
    var tmp;
    if ($this.k1d_1 || !isString) {
      tmp = $this.j1d_1.r1d();
    } else {
      tmp = $this.j1d_1.q1d();
    }
    var string = tmp;
    if (!isString && string === 'null')
      return JsonNull_getInstance();
    return new JsonLiteral(string, isString);
  }
  function readDeepRecursive($this) {
    return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
  }
  function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
    this.q1e_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsonTreeReader$readDeepRecursive$slambda).v1e = function ($this$DeepRecursiveFunction, it, $completion) {
    var tmp = this.w1e($this$DeepRecursiveFunction, it, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).da = function (p1, p2, $completion) {
    var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
    return this.v1e(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 3;
            this.t1e_1 = this.q1e_1.j1d_1.o1d();
            if (this.t1e_1 === 1) {
              this.u1e_1 = readValue(this.q1e_1, true);
              this.g9_1 = 2;
              continue $sm;
            } else {
              if (this.t1e_1 === 0) {
                this.u1e_1 = readValue(this.q1e_1, false);
                this.g9_1 = 2;
                continue $sm;
              } else {
                if (this.t1e_1 === 6) {
                  this.g9_1 = 1;
                  suspendResult = readObject_0(this.r1e_1, this.q1e_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (this.t1e_1 === 8) {
                    this.u1e_1 = readArray(this.q1e_1);
                    this.g9_1 = 2;
                    continue $sm;
                  } else {
                    var tmp_0 = this;
                    this.q1e_1.j1d_1.m1c("Can't begin reading element, unexpected token");
                  }
                }
              }
            }

            break;
          case 1:
            this.u1e_1 = suspendResult;
            this.g9_1 = 2;
            continue $sm;
          case 2:
            return this.u1e_1;
          case 3:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 3) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  protoOf(JsonTreeReader$readDeepRecursive$slambda).w1e = function ($this$DeepRecursiveFunction, it, completion) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this.q1e_1, completion);
    i.r1e_1 = $this$DeepRecursiveFunction;
    i.s1e_1 = it;
    return i;
  };
  function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
    var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
    var l = function ($this$DeepRecursiveFunction, it, $completion) {
      return i.v1e($this$DeepRecursiveFunction, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function $readObjectCOROUTINE$0(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.c1e_1 = _this__u8e3s4;
    this.d1e_1 = _this__u8e3s4_0;
  }
  protoOf($readObjectCOROUTINE$0).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 5;
            var tmp_0 = this;
            tmp_0.e1e_1 = this.c1e_1;
            this.f1e_1 = this.e1e_1.j1d_1.n1d(6);
            if (this.e1e_1.j1d_1.o1d() === 4) {
              this.e1e_1.j1d_1.m1c('Unexpected leading comma');
            }

            var tmp_1 = this;
            tmp_1.g1e_1 = LinkedHashMap_init_$Create$();
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!this.e1e_1.j1d_1.p1d()) {
              this.g9_1 = 4;
              continue $sm;
            }

            this.h1e_1 = this.e1e_1.k1d_1 ? this.e1e_1.j1d_1.r1d() : this.e1e_1.j1d_1.q1d();
            this.e1e_1.j1d_1.n1d(5);
            this.g9_1 = 2;
            suspendResult = this.d1e_1.sk(Unit_instance, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var element = suspendResult;
            var this_0 = this.g1e_1;
            var key = this.h1e_1;
            this_0.k2(key, element);
            this.f1e_1 = this.e1e_1.j1d_1.t1d();
            var tmp0_subject = this.f1e_1;
            if (tmp0_subject === 4) {
              this.g9_1 = 3;
              continue $sm;
            } else {
              if (tmp0_subject === 7) {
                this.g9_1 = 4;
                continue $sm;
              } else {
                this.e1e_1.j1d_1.m1c('Expected end of the object or comma');
              }
            }

            break;
          case 3:
            this.g9_1 = 1;
            continue $sm;
          case 4:
            if (this.f1e_1 === 6) {
              this.e1e_1.j1d_1.n1d(7);
            } else if (this.f1e_1 === 4) {
              if (!this.e1e_1.l1d_1) {
                invalidTrailingComma(this.e1e_1.j1d_1);
              }
              this.e1e_1.j1d_1.n1d(7);
            }

            return new JsonObject(this.g1e_1);
          case 5:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 5) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function JsonTreeReader(configuration, lexer) {
    this.j1d_1 = lexer;
    this.k1d_1 = configuration.f19_1;
    this.l1d_1 = configuration.r19_1;
    this.m1d_1 = 0;
  }
  protoOf(JsonTreeReader).s1d = function () {
    var token = this.j1d_1.o1d();
    var tmp;
    if (token === 1) {
      tmp = readValue(this, true);
    } else if (token === 0) {
      tmp = readValue(this, false);
    } else if (token === 6) {
      var tmp_0;
      this.m1d_1 = this.m1d_1 + 1 | 0;
      if (this.m1d_1 === 200) {
        tmp_0 = readDeepRecursive(this);
      } else {
        tmp_0 = readObject(this);
      }
      var result = tmp_0;
      this.m1d_1 = this.m1d_1 - 1 | 0;
      tmp = result;
    } else if (token === 8) {
      tmp = readArray(this);
    } else {
      this.j1d_1.m1c('Cannot read Json element because of unexpected ' + tokenDescription(token));
    }
    return tmp;
  };
  function classDiscriminator(_this__u8e3s4, json) {
    var _iterator__ex2g4s = _this__u8e3s4.ap().g();
    while (_iterator__ex2g4s.h()) {
      var annotation = _iterator__ex2g4s.i();
      if (annotation instanceof JsonClassDiscriminator)
        return annotation.x1e_1;
    }
    return json.r17_1.m19_1;
  }
  function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
    if (!(serializer instanceof SealedClassSerializer))
      return Unit_instance;
    if (jsonCachedSerialNames(actualSerializer.nn()).r(classDiscriminator)) {
      var baseName = serializer.nn().wo();
      var actualName = actualSerializer.nn().wo();
      // Inline function 'kotlin.error' call
      var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation or fall back to array polymorphism';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function checkKind(kind) {
    if (kind instanceof ENUM) {
      // Inline function 'kotlin.error' call
      var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message));
    }
    if (kind instanceof PrimitiveKind) {
      // Inline function 'kotlin.error' call
      var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
      throw IllegalStateException_init_$Create$(toString(message_0));
    }
    if (kind instanceof PolymorphicKind) {
      // Inline function 'kotlin.error' call
      var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
      throw IllegalStateException_init_$Create$(toString(message_1));
    }
  }
  function validateIfSealed$accessor$iffjvx(serializer, actualSerializer, classDiscriminator) {
    return validateIfSealed(serializer, actualSerializer, classDiscriminator);
  }
  function checkKind_0($this, descriptor, actualClass) {
    var kind = descriptor.xo();
    var tmp;
    if (kind instanceof PolymorphicKind) {
      tmp = true;
    } else {
      tmp = equals(kind, CONTEXTUAL_getInstance());
    }
    if (tmp) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.cb() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
    }
    if ($this.y1e_1)
      return Unit_instance;
    var tmp_0;
    var tmp_1;
    if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
      tmp_1 = true;
    } else {
      tmp_1 = kind instanceof PrimitiveKind;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = kind instanceof ENUM;
    }
    if (tmp_0) {
      throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.cb() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
    }
  }
  function checkDiscriminatorCollisions($this, descriptor, actualClass) {
    var inductionVariable = 0;
    var last = descriptor.zo();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var name = descriptor.bp(i);
        if (name === $this.z1e_1) {
          throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, ' + 'rename property with @SerialName annotation ' + 'or fall back to array polymorphism');
        }
      }
       while (inductionVariable < last);
  }
  function PolymorphismValidator(useArrayPolymorphism, discriminator) {
    this.y1e_1 = useArrayPolymorphism;
    this.z1e_1 = discriminator;
  }
  protoOf(PolymorphismValidator).i17 = function (kClass, provider) {
  };
  protoOf(PolymorphismValidator).l17 = function (baseClass, actualClass, actualSerializer) {
    var descriptor = actualSerializer.nn();
    checkKind_0(this, descriptor, actualClass);
    if (!this.y1e_1) {
      checkDiscriminatorCollisions(this, descriptor, actualClass);
    }
  };
  protoOf(PolymorphismValidator).m17 = function (baseClass, defaultSerializerProvider) {
  };
  protoOf(PolymorphismValidator).n17 = function (baseClass, defaultDeserializerProvider) {
  };
  function Key() {
  }
  function DescriptorSchemaCache() {
    this.n1c_1 = createMapForCache(16);
  }
  protoOf(DescriptorSchemaCache).a1f = function (descriptor, key, value) {
    // Inline function 'kotlin.collections.set' call
    // Inline function 'kotlin.collections.getOrPut' call
    var this_0 = this.n1c_1;
    var value_0 = this_0.b2(descriptor);
    var tmp;
    if (value_0 == null) {
      // Inline function 'kotlinx.serialization.json.internal.DescriptorSchemaCache.set.<anonymous>' call
      var answer = createMapForCache(2);
      this_0.k2(descriptor, answer);
      tmp = answer;
    } else {
      tmp = value_0;
    }
    var this_1 = tmp;
    var key_0 = key instanceof Key ? key : THROW_CCE();
    var value_1 = !(value == null) ? value : THROW_CCE();
    this_1.k2(key_0, value_1);
  };
  protoOf(DescriptorSchemaCache).o1c = function (descriptor, key, defaultValue) {
    var tmp0_safe_receiver = this.b1f(descriptor, key);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var value = defaultValue();
    this.a1f(descriptor, key, value);
    return value;
  };
  protoOf(DescriptorSchemaCache).b1f = function (descriptor, key) {
    var tmp0_safe_receiver = this.n1c_1.b2(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      tmp = tmp0_safe_receiver.b2(key instanceof Key ? key : THROW_CCE());
    }
    var tmp_0 = tmp;
    return !(tmp_0 == null) ? tmp_0 : null;
  };
  function DiscriminatorHolder(discriminatorToSkip) {
    this.c1f_1 = discriminatorToSkip;
  }
  function trySkip(_this__u8e3s4, $this, unknownKey) {
    if (_this__u8e3s4 == null)
      return false;
    if (_this__u8e3s4.c1f_1 === unknownKey) {
      _this__u8e3s4.c1f_1 = null;
      return true;
    }
    return false;
  }
  function skipLeftoverElements($this, descriptor) {
    while (!($this.jr(descriptor) === -1)) {
    }
  }
  function checkLeadingComma($this) {
    if ($this.z17_1.o1d() === 4) {
      $this.z17_1.m1c('Unexpected leading comma');
    }
  }
  function decodeMapIndex($this) {
    var hasComma = false;
    var decodingKey = !(($this.b18_1 % 2 | 0) === 0);
    if (decodingKey) {
      if (!($this.b18_1 === -1)) {
        hasComma = $this.z17_1.e1f();
      }
    } else {
      $this.z17_1.d1f(_Char___init__impl__6a9atx(58));
    }
    var tmp;
    if ($this.z17_1.p1d()) {
      if (decodingKey) {
        if ($this.b18_1 === -1) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_0 = $this.z17_1;
          var condition = !hasComma;
          var position = this_0.f18_1;
          if (!condition) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$0 = 'Unexpected leading comma';
            this_0.m1c(tmp$ret$0, position);
          }
        } else {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
          var this_1 = $this.z17_1;
          var condition_0 = hasComma;
          var position_0 = this_1.f18_1;
          if (!condition_0) {
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeMapIndex.<anonymous>' call
            var tmp$ret$1 = 'Expected comma after the key-value pair';
            this_1.m1c(tmp$ret$1, position_0);
          }
        }
      }
      $this.b18_1 = $this.b18_1 + 1 | 0;
      tmp = $this.b18_1;
    } else {
      if (hasComma && !$this.x17_1.r17_1.r19_1) {
        invalidTrailingComma($this.z17_1);
      }
      tmp = -1;
    }
    return tmp;
  }
  function coerceInputValue($this, descriptor, index) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.x17_1;
      var isOptional = descriptor.fp(index);
      var elementDescriptor = descriptor.ep(index);
      var tmp;
      if (isOptional && !elementDescriptor.so()) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        tmp = $this.z17_1.f1f(true);
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.xo(), ENUM_getInstance())) {
        var tmp_0;
        if (elementDescriptor.so()) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          tmp_0 = $this.z17_1.f1f(false);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
        var tmp0_elvis_lhs = $this.z17_1.g1f($this.d18_1.f19_1);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_1;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        var coerceToNull = !this_0.r17_1.i19_1 && elementDescriptor.so();
        if (enumIndex === -3 && (isOptional || coerceToNull)) {
          // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.coerceInputValue.<anonymous>' call
          $this.z17_1.q1d();
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function decodeObjectIndex($this, descriptor) {
    var hasComma = $this.z17_1.e1f();
    while ($this.z17_1.p1d()) {
      hasComma = false;
      var key = decodeStringKey($this);
      $this.z17_1.d1f(_Char___init__impl__6a9atx(58));
      var index = getJsonNameIndex(descriptor, $this.x17_1, key);
      var tmp;
      if (!(index === -3)) {
        var tmp_0;
        if ($this.d18_1.k19_1 && coerceInputValue($this, descriptor, index)) {
          hasComma = $this.z17_1.e1f();
          tmp_0 = false;
        } else {
          var tmp0_safe_receiver = $this.e18_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.j1c(index);
          }
          return index;
        }
        tmp = tmp_0;
      } else {
        tmp = true;
      }
      var isUnknown = tmp;
      if (isUnknown) {
        hasComma = handleUnknown($this, key);
      }
    }
    if (hasComma && !$this.x17_1.r17_1.r19_1) {
      invalidTrailingComma($this.z17_1);
    }
    var tmp1_safe_receiver = $this.e18_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k1c();
    return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
  }
  function handleUnknown($this, key) {
    if ($this.d18_1.e19_1 || trySkip($this.c18_1, $this, key)) {
      $this.z17_1.i1f($this.d18_1.f19_1);
    } else {
      $this.z17_1.h1f(key);
    }
    return $this.z17_1.e1f();
  }
  function decodeListIndex($this) {
    var hasComma = $this.z17_1.e1f();
    var tmp;
    if ($this.z17_1.p1d()) {
      if (!($this.b18_1 === -1) && !hasComma) {
        $this.z17_1.m1c('Expected end of the array or comma');
      }
      $this.b18_1 = $this.b18_1 + 1 | 0;
      tmp = $this.b18_1;
    } else {
      if (hasComma && !$this.x17_1.r17_1.r19_1) {
        invalidTrailingComma($this.z17_1, 'array');
      }
      tmp = -1;
    }
    return tmp;
  }
  function decodeStringKey($this) {
    var tmp;
    if ($this.d18_1.f19_1) {
      tmp = $this.z17_1.k1f();
    } else {
      tmp = $this.z17_1.j1f();
    }
    return tmp;
  }
  function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
    AbstractDecoder.call(this);
    this.x17_1 = json;
    this.y17_1 = mode;
    this.z17_1 = lexer;
    this.a18_1 = this.x17_1.jo();
    this.b18_1 = -1;
    this.c18_1 = discriminatorHolder;
    this.d18_1 = this.x17_1.r17_1;
    this.e18_1 = this.d18_1.i19_1 ? null : new JsonElementMarker(descriptor);
  }
  protoOf(StreamingJsonDecoder).u19 = function () {
    return this.x17_1;
  };
  protoOf(StreamingJsonDecoder).jo = function () {
    return this.a18_1;
  };
  protoOf(StreamingJsonDecoder).v19 = function () {
    return (new JsonTreeReader(this.x17_1.r17_1, this.z17_1)).s1d();
  };
  protoOf(StreamingJsonDecoder).sq = function (deserializer) {
    try {
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.x17_1.r17_1.l19_1;
      }
      if (tmp) {
        return deserializer.pn(this);
      }
      var discriminator = classDiscriminator(deserializer.nn(), this.x17_1);
      var tmp0_elvis_lhs = this.z17_1.l1f(discriminator, this.d18_1.f19_1);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
          var deserializer_0 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
          var tmp_1;
          if (!(deserializer_0 instanceof AbstractPolymorphicSerializer)) {
            tmp_1 = true;
          } else {
            tmp_1 = this.u19().r17_1.l19_1;
          }
          if (tmp_1) {
            tmp$ret$0 = deserializer_0.pn(this);
            break $l$block;
          }
          var discriminator_0 = classDiscriminator(deserializer_0.nn(), this.u19());
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var value = this.v19();
          var serialName = deserializer_0.nn().wo();
          if (!(value instanceof JsonObject)) {
            var tmp_2 = getKClass(JsonObject).cb();
            var tmp_3 = getKClassFromExpression(value).cb();
            // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeSerializableValue.<anonymous>' call
            var tmp$ret$1 = this.z17_1.g18_1.z1c();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
          }
          var jsonTree = value;
          var tmp0_safe_receiver = jsonTree.de(discriminator_0);
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
          var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
          var tmp_4;
          try {
            tmp_4 = findPolymorphicSerializer(deserializer_0, this, type);
          } catch ($p) {
            var tmp_5;
            if ($p instanceof SerializationException) {
              var it = $p;
              throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
            } else {
              throw $p;
            }
          }
          var tmp_6 = tmp_4;
          var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
          tmp$ret$0 = readPolymorphicJson(this.u19(), discriminator_0, jsonTree, actualSerializer);
        }
        return tmp$ret$0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var type_0 = tmp_0;
      var tmp_7;
      try {
        tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
      } catch ($p) {
        var tmp_8;
        if ($p instanceof SerializationException) {
          var it_0 = $p;
          var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
          var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
          this.z17_1.m1c(message, VOID, hint);
        } else {
          throw $p;
        }
        tmp_7 = tmp_8;
      }
      var tmp_9 = tmp_7;
      var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
      this.c18_1 = new DiscriminatorHolder(discriminator);
      return actualSerializer_0.pn(this);
    } catch ($p) {
      if ($p instanceof MissingFieldException) {
        var e = $p;
        if (contains_0(ensureNotNull(e.message), 'at path'))
          throw e;
        throw new MissingFieldException(e.mo_1, plus(e.message, ' at path: ') + this.z17_1.g18_1.z1c(), e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(StreamingJsonDecoder).tq = function (descriptor) {
    var newMode = switchMode(this.x17_1, descriptor);
    this.z17_1.g18_1.u1c(descriptor);
    this.z17_1.d1f(newMode.o1f_1);
    checkLeadingComma(this);
    var tmp;
    switch (newMode.o2_1) {
      case 1:
      case 2:
      case 3:
        tmp = new StreamingJsonDecoder(this.x17_1, newMode, this.z17_1, descriptor, this.c18_1);
        break;
      default:
        var tmp_0;
        if (this.y17_1.equals(newMode) && this.x17_1.r17_1.i19_1) {
          tmp_0 = this;
        } else {
          tmp_0 = new StreamingJsonDecoder(this.x17_1, newMode, this.z17_1, descriptor, this.c18_1);
        }

        tmp = tmp_0;
        break;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).uq = function (descriptor) {
    if (this.x17_1.r17_1.e19_1 && descriptor.zo() === 0) {
      skipLeftoverElements(this, descriptor);
    }
    if (this.z17_1.e1f() && !this.x17_1.r17_1.r19_1) {
      invalidTrailingComma(this.z17_1, '');
    }
    this.z17_1.d1f(this.y17_1.p1f_1);
    this.z17_1.g18_1.y1c();
  };
  protoOf(StreamingJsonDecoder).eq = function () {
    var tmp;
    var tmp0_safe_receiver = this.e18_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i1c_1;
    if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
      tmp = !this.z17_1.q1f();
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).fq = function () {
    return null;
  };
  protoOf(StreamingJsonDecoder).fr = function (descriptor, index, deserializer, previousValue) {
    var isMapKey = this.y17_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
    if (isMapKey) {
      this.z17_1.g18_1.x1c();
    }
    var value = protoOf(AbstractDecoder).fr.call(this, descriptor, index, deserializer, previousValue);
    if (isMapKey) {
      this.z17_1.g18_1.w1c(value);
    }
    return value;
  };
  protoOf(StreamingJsonDecoder).jr = function (descriptor) {
    var index;
    switch (this.y17_1.o2_1) {
      case 0:
        index = decodeObjectIndex(this, descriptor);
        break;
      case 2:
        index = decodeMapIndex(this);
        break;
      default:
        index = decodeListIndex(this);
        break;
    }
    if (!this.y17_1.equals(WriteMode_MAP_getInstance())) {
      this.z17_1.g18_1.v1c(index);
    }
    return index;
  };
  protoOf(StreamingJsonDecoder).gq = function () {
    return this.z17_1.r1f();
  };
  protoOf(StreamingJsonDecoder).hq = function () {
    var value = this.z17_1.i1a();
    if (!value.equals(toLong(value.j3()))) {
      this.z17_1.m1c("Failed to parse byte for input '" + value.toString() + "'");
    }
    return value.j3();
  };
  protoOf(StreamingJsonDecoder).iq = function () {
    var value = this.z17_1.i1a();
    if (!value.equals(toLong(value.k3()))) {
      this.z17_1.m1c("Failed to parse short for input '" + value.toString() + "'");
    }
    return value.k3();
  };
  protoOf(StreamingJsonDecoder).jq = function () {
    var value = this.z17_1.i1a();
    if (!value.equals(toLong(value.g1()))) {
      this.z17_1.m1c("Failed to parse int for input '" + value.toString() + "'");
    }
    return value.g1();
  };
  protoOf(StreamingJsonDecoder).kq = function () {
    return this.z17_1.i1a();
  };
  protoOf(StreamingJsonDecoder).lq = function () {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.z17_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeFloat.<anonymous>' call
        // Inline function 'kotlin.text.toFloat' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$4 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'float' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.x17_1.r17_1.n19_1;
    if (specialFp || isFinite(result))
      return result;
    throwInvalidFloatingPointDecoded(this.z17_1, result);
  };
  protoOf(StreamingJsonDecoder).mq = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.z17_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonDecoder.decodeDouble.<anonymous>' call
        tmp$ret$1 = toDouble(input);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'double' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$1;
    var specialFp = this.x17_1.r17_1.n19_1;
    if (specialFp || isFinite_0(result))
      return result;
    throwInvalidFloatingPointDecoded(this.z17_1, result);
  };
  protoOf(StreamingJsonDecoder).nq = function () {
    var string = this.z17_1.r1d();
    if (!(string.length === 1)) {
      this.z17_1.m1c("Expected single char, but got '" + string + "'");
    }
    return charSequenceGet(string, 0);
  };
  protoOf(StreamingJsonDecoder).oq = function () {
    var tmp;
    if (this.d18_1.f19_1) {
      tmp = this.z17_1.k1f();
    } else {
      tmp = this.z17_1.q1d();
    }
    return tmp;
  };
  protoOf(StreamingJsonDecoder).qq = function (descriptor) {
    return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.z17_1, this.x17_1) : protoOf(AbstractDecoder).qq.call(this, descriptor);
  };
  protoOf(StreamingJsonDecoder).pq = function (enumDescriptor) {
    return getJsonNameIndexOrThrow(enumDescriptor, this.x17_1, this.oq(), ' at path ' + this.z17_1.g18_1.z1c());
  };
  function JsonDecoderForUnsignedTypes(lexer, json) {
    AbstractDecoder.call(this);
    this.s1f_1 = lexer;
    this.t1f_1 = json.jo();
  }
  protoOf(JsonDecoderForUnsignedTypes).jo = function () {
    return this.t1f_1;
  };
  protoOf(JsonDecoderForUnsignedTypes).jr = function (descriptor) {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(JsonDecoderForUnsignedTypes).jq = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.s1f_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeInt.<anonymous>' call
        // Inline function 'kotlin.UInt.toInt' call
        var this_1 = toUInt(input);
        tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).kq = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.s1f_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeLong.<anonymous>' call
        // Inline function 'kotlin.ULong.toLong' call
        var this_1 = toULong(input);
        tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).hq = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.s1f_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeByte.<anonymous>' call
        // Inline function 'kotlin.UByte.toByte' call
        var this_1 = toUByte(input);
        tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  protoOf(JsonDecoderForUnsignedTypes).iq = function () {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.parseString' call
      var this_0 = this.s1f_1;
      var input = this_0.r1d();
      try {
        // Inline function 'kotlinx.serialization.json.internal.JsonDecoderForUnsignedTypes.decodeShort.<anonymous>' call
        // Inline function 'kotlin.UShort.toShort' call
        var this_1 = toUShort(input);
        tmp$ret$2 = _UShort___get_data__impl__g0245(this_1);
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          this_0.m1c("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$2;
  };
  function get_unsignedNumberDescriptors() {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return unsignedNumberDescriptors;
  }
  var unsignedNumberDescriptors;
  function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
    StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
    return $this;
  }
  function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
    return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
  }
  function encodeTypeInfo($this, discriminator, serialName) {
    $this.a1d_1.g1b();
    $this.wr(discriminator);
    $this.a1d_1.j1b(_Char___init__impl__6a9atx(58));
    $this.a1d_1.i1b();
    $this.wr(serialName);
  }
  function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
    AbstractEncoder.call(this);
    this.a1d_1 = composer;
    this.b1d_1 = json;
    this.c1d_1 = mode;
    this.d1d_1 = modeReuseCache;
    this.e1d_1 = this.b1d_1.jo();
    this.f1d_1 = this.b1d_1.r17_1;
    this.g1d_1 = false;
    this.h1d_1 = null;
    this.i1d_1 = null;
    var i = this.c1d_1.o2_1;
    if (!(this.d1d_1 == null)) {
      if (!(this.d1d_1[i] === null) || !(this.d1d_1[i] === this)) {
        this.d1d_1[i] = this;
      }
    }
  }
  protoOf(StreamingJsonEncoder).u19 = function () {
    return this.b1d_1;
  };
  protoOf(StreamingJsonEncoder).jo = function () {
    return this.e1d_1;
  };
  protoOf(StreamingJsonEncoder).ps = function (descriptor, index) {
    return this.f1d_1.d19_1;
  };
  protoOf(StreamingJsonEncoder).ks = function (serializer, value) {
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
      if (this.u19().r17_1.l19_1) {
        serializer.on(this, value);
        break $l$block;
      }
      var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
      var tmp;
      if (isPolymorphicSerializer) {
        tmp = !this.u19().r17_1.t19_1.equals(ClassDiscriminatorMode_NONE_getInstance());
      } else {
        var tmp_0;
        switch (this.u19().r17_1.t19_1.o2_1) {
          case 0:
          case 2:
            tmp_0 = false;
            break;
          case 1:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call

            var it = serializer.nn().xo();
            tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        tmp = tmp_0;
      }
      var needDiscriminator = tmp;
      var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.nn(), this.u19()) : null;
      var tmp_1;
      if (isPolymorphicSerializer) {
        var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
        $l$block_0: {
          // Inline function 'kotlin.requireNotNull' call
          // Inline function 'kotlin.contracts.contract' call
          if (value == null) {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically.<anonymous>' call
            var message = 'Value for serializer ' + toString(serializer.nn()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
            throw IllegalArgumentException_init_$Create$(toString(message));
          } else {
            break $l$block_0;
          }
        }
        var actual = findPolymorphicSerializer_0(casted, this, value);
        if (!(baseClassDiscriminator == null)) {
          validateIfSealed$accessor$iffjvx(serializer, actual, baseClassDiscriminator);
        }
        checkKind(actual.nn().xo());
        tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
      } else {
        tmp_1 = serializer;
      }
      var actualSerializer = tmp_1;
      if (!(baseClassDiscriminator == null)) {
        // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeSerializableValue.<anonymous>' call
        var serialName = actualSerializer.nn().wo();
        this.h1d_1 = baseClassDiscriminator;
        this.i1d_1 = serialName;
      }
      actualSerializer.on(this, value);
    }
  };
  protoOf(StreamingJsonEncoder).tq = function (descriptor) {
    var newMode = switchMode(this.b1d_1, descriptor);
    if (!(newMode.o1f_1 === _Char___init__impl__6a9atx(0))) {
      this.a1d_1.j1b(newMode.o1f_1);
      this.a1d_1.e1b();
    }
    var discriminator = this.h1d_1;
    if (!(discriminator == null)) {
      var tmp0_elvis_lhs = this.i1d_1;
      encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.wo() : tmp0_elvis_lhs);
      this.h1d_1 = null;
      this.i1d_1 = null;
    }
    if (this.c1d_1.equals(newMode)) {
      return this;
    }
    var tmp1_safe_receiver = this.d1d_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.o2_1];
    return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.a1d_1, this.b1d_1, newMode, this.d1d_1) : tmp2_elvis_lhs;
  };
  protoOf(StreamingJsonEncoder).uq = function (descriptor) {
    if (!(this.c1d_1.p1f_1 === _Char___init__impl__6a9atx(0))) {
      this.a1d_1.f1b();
      this.a1d_1.h1b();
      this.a1d_1.j1b(this.c1d_1.p1f_1);
    }
  };
  protoOf(StreamingJsonEncoder).lr = function (descriptor, index) {
    switch (this.c1d_1.o2_1) {
      case 1:
        if (!this.a1d_1.d1b_1) {
          this.a1d_1.j1b(_Char___init__impl__6a9atx(44));
        }

        this.a1d_1.g1b();
        break;
      case 2:
        if (!this.a1d_1.d1b_1) {
          var tmp = this;
          var tmp_0;
          if ((index % 2 | 0) === 0) {
            this.a1d_1.j1b(_Char___init__impl__6a9atx(44));
            this.a1d_1.g1b();
            tmp_0 = true;
          } else {
            this.a1d_1.j1b(_Char___init__impl__6a9atx(58));
            this.a1d_1.i1b();
            tmp_0 = false;
          }
          tmp.g1d_1 = tmp_0;
        } else {
          this.g1d_1 = true;
          this.a1d_1.g1b();
        }

        break;
      case 3:
        if (index === 0)
          this.g1d_1 = true;
        if (index === 1) {
          this.a1d_1.j1b(_Char___init__impl__6a9atx(44));
          this.a1d_1.i1b();
          this.g1d_1 = false;
        }

        break;
      default:
        if (!this.a1d_1.d1b_1) {
          this.a1d_1.j1b(_Char___init__impl__6a9atx(44));
        }

        this.a1d_1.g1b();
        this.wr(getJsonElementName(descriptor, this.b1d_1, index));
        this.a1d_1.j1b(_Char___init__impl__6a9atx(58));
        this.a1d_1.i1b();
        break;
    }
    return true;
  };
  protoOf(StreamingJsonEncoder).ls = function (descriptor, index, serializer, value) {
    if (!(value == null) || this.f1d_1.i19_1) {
      protoOf(AbstractEncoder).ls.call(this, descriptor, index, serializer, value);
    }
  };
  protoOf(StreamingJsonEncoder).yr = function (descriptor) {
    var tmp;
    if (get_isUnsignedNumber(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_0;
      var tmp_1 = this.a1d_1;
      if (tmp_1 instanceof ComposerForUnsignedNumbers) {
        tmp_0 = this.a1d_1;
      } else {
        var p0 = this.a1d_1.c1b_1;
        var p1 = this.g1d_1;
        tmp_0 = new ComposerForUnsignedNumbers(p0, p1);
      }
      var tmp$ret$1 = tmp_0;
      tmp = new StreamingJsonEncoder(tmp$ret$1, this.b1d_1, this.c1d_1, null);
    } else if (get_isUnquotedLiteral(descriptor)) {
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
      var tmp_2;
      var tmp_3 = this.a1d_1;
      if (tmp_3 instanceof ComposerForUnquotedLiterals) {
        tmp_2 = this.a1d_1;
      } else {
        var p0_0 = this.a1d_1.c1b_1;
        var p1_0 = this.g1d_1;
        tmp_2 = new ComposerForUnquotedLiterals(p0_0, p1_0);
      }
      var tmp$ret$3 = tmp_2;
      tmp = new StreamingJsonEncoder(tmp$ret$3, this.b1d_1, this.c1d_1, null);
    } else if (!(this.h1d_1 == null)) {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.encodeInline.<anonymous>' call
      this.i1d_1 = descriptor.wo();
      tmp = this;
    } else {
      tmp = protoOf(AbstractEncoder).yr.call(this, descriptor);
    }
    return tmp;
  };
  protoOf(StreamingJsonEncoder).nr = function () {
    this.a1d_1.l1b('null');
  };
  protoOf(StreamingJsonEncoder).or = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.u1b(value);
    }
  };
  protoOf(StreamingJsonEncoder).pr = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.p1b(value);
    }
  };
  protoOf(StreamingJsonEncoder).qr = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.r1b(value);
    }
  };
  protoOf(StreamingJsonEncoder).rr = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.s1b(value);
    }
  };
  protoOf(StreamingJsonEncoder).sr = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.t1b(value);
    }
  };
  protoOf(StreamingJsonEncoder).tr = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.n1b(value);
    }
    if (!this.f1d_1.n19_1 && !isFinite(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.a1d_1.c1b_1));
    }
  };
  protoOf(StreamingJsonEncoder).ur = function (value) {
    if (this.g1d_1) {
      this.wr(value.toString());
    } else {
      this.a1d_1.o1b(value);
    }
    if (!this.f1d_1.n19_1 && !isFinite_0(value)) {
      throw InvalidFloatingPointEncoded(value, toString(this.a1d_1.c1b_1));
    }
  };
  protoOf(StreamingJsonEncoder).vr = function (value) {
    this.wr(toString_1(value));
  };
  protoOf(StreamingJsonEncoder).wr = function (value) {
    return this.a1d_1.v1b(value);
  };
  protoOf(StreamingJsonEncoder).xr = function (enumDescriptor, index) {
    this.wr(enumDescriptor.bp(index));
  };
  function get_isUnsignedNumber(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.yo() && get_unsignedNumberDescriptors().r(_this__u8e3s4);
  }
  function get_isUnquotedLiteral(_this__u8e3s4) {
    _init_properties_StreamingJsonEncoder_kt__pn1bsi();
    return _this__u8e3s4.yo() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
  }
  var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
  function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
    if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
      properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
      unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).nn(), serializer_0(Companion_getInstance()).nn(), serializer_2(Companion_getInstance_1()).nn(), serializer_3(Companion_getInstance_2()).nn()]);
    }
  }
  function get_ESCAPE_STRINGS() {
    _init_properties_StringOps_kt__fcy1db();
    return ESCAPE_STRINGS;
  }
  var ESCAPE_STRINGS;
  var ESCAPE_MARKERS;
  function toHexChar(i) {
    _init_properties_StringOps_kt__fcy1db();
    var d = i & 15;
    var tmp;
    if (d < 10) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
      tmp = numberToChar(d + tmp$ret$0 | 0);
    } else {
      var tmp_0 = d - 10 | 0;
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
    }
    return tmp;
  }
  function printQuoted(_this__u8e3s4, value) {
    _init_properties_StringOps_kt__fcy1db();
    _this__u8e3s4.j8(_Char___init__impl__6a9atx(34));
    var lastPos = 0;
    var inductionVariable = 0;
    var last = charSequenceLength(value) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(value, i);
        var c = Char__toInt_impl_vasixd(this_0);
        if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
          _this__u8e3s4.sc(value, lastPos, i);
          _this__u8e3s4.i8(get_ESCAPE_STRINGS()[c]);
          lastPos = i + 1 | 0;
        }
      }
       while (inductionVariable <= last);
    if (!(lastPos === 0))
      _this__u8e3s4.sc(value, lastPos, value.length);
    else
      _this__u8e3s4.i8(value);
    _this__u8e3s4.j8(_Char___init__impl__6a9atx(34));
  }
  function toBooleanStrictOrNull_0(_this__u8e3s4) {
    _init_properties_StringOps_kt__fcy1db();
    return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
  }
  var properties_initialized_StringOps_kt_wzaea7;
  function _init_properties_StringOps_kt__fcy1db() {
    if (!properties_initialized_StringOps_kt_wzaea7) {
      properties_initialized_StringOps_kt_wzaea7 = true;
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.arrayOfNulls' call
      var this_0 = fillArrayVal(Array(93), null);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_STRINGS.<anonymous>' call
      var inductionVariable = 0;
      if (inductionVariable <= 31)
        do {
          var c = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var c1 = toHexChar(c >> 12);
          var c2 = toHexChar(c >> 8);
          var c3 = toHexChar(c >> 4);
          var c4 = toHexChar(c);
          this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
        }
         while (inductionVariable <= 31);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(34);
      this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(92);
      this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(9);
      this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(8);
      this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(10);
      this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
      // Inline function 'kotlin.code' call
      var this_6 = _Char___init__impl__6a9atx(13);
      this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
      this_0[12] = '\\f';
      ESCAPE_STRINGS = this_0;
      // Inline function 'kotlin.apply' call
      var this_7 = new Int8Array(93);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.ESCAPE_MARKERS.<anonymous>' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 <= 31)
        do {
          var c_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this_7[c_0] = 1;
        }
         while (inductionVariable_0 <= 31);
      // Inline function 'kotlin.code' call
      var this_8 = _Char___init__impl__6a9atx(34);
      this_7[Char__toInt_impl_vasixd(this_8)] = 34;
      // Inline function 'kotlin.code' call
      var this_9 = _Char___init__impl__6a9atx(92);
      this_7[Char__toInt_impl_vasixd(this_9)] = 92;
      // Inline function 'kotlin.code' call
      var this_10 = _Char___init__impl__6a9atx(9);
      this_7[Char__toInt_impl_vasixd(this_10)] = 116;
      // Inline function 'kotlin.code' call
      var this_11 = _Char___init__impl__6a9atx(8);
      this_7[Char__toInt_impl_vasixd(this_11)] = 98;
      // Inline function 'kotlin.code' call
      var this_12 = _Char___init__impl__6a9atx(10);
      this_7[Char__toInt_impl_vasixd(this_12)] = 110;
      // Inline function 'kotlin.code' call
      var this_13 = _Char___init__impl__6a9atx(13);
      this_7[Char__toInt_impl_vasixd(this_13)] = 114;
      this_7[12] = 102;
      ESCAPE_MARKERS = this_7;
    }
  }
  function unparsedPrimitive($this, literal, primitive, tag) {
    var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
    throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.a1g(tag), toString($this.b1g()));
  }
  function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    NamedValueDecoder.call(this);
    this.w1f_1 = json;
    this.x1f_1 = value;
    this.y1f_1 = polymorphicDiscriminator;
    this.z1f_1 = this.u19().r17_1;
  }
  protoOf(AbstractJsonTreeDecoder).u19 = function () {
    return this.w1f_1;
  };
  protoOf(AbstractJsonTreeDecoder).w = function () {
    return this.x1f_1;
  };
  protoOf(AbstractJsonTreeDecoder).jo = function () {
    return this.u19().jo();
  };
  protoOf(AbstractJsonTreeDecoder).b1g = function () {
    var tmp0_safe_receiver = this.y14();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.currentObject.<anonymous>' call
      tmp = this.c1g(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? this.w() : tmp1_elvis_lhs;
  };
  protoOf(AbstractJsonTreeDecoder).a1g = function (currentTag) {
    return this.a15() + ('.' + currentTag);
  };
  protoOf(AbstractJsonTreeDecoder).v19 = function () {
    return this.b1g();
  };
  protoOf(AbstractJsonTreeDecoder).sq = function (deserializer) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
      var tmp;
      if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
        tmp = true;
      } else {
        tmp = this.u19().r17_1.l19_1;
      }
      if (tmp) {
        tmp$ret$0 = deserializer.pn(this);
        break $l$block;
      }
      var discriminator = classDiscriminator(deserializer.nn(), this.u19());
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.v19();
      var serialName = deserializer.nn().wo();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).cb();
        var tmp_1 = getKClassFromExpression(value).cb();
        var tmp$ret$1 = this.a15();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(value));
      }
      var jsonTree = value;
      var tmp0_safe_receiver = jsonTree.de(discriminator);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
      var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
      var tmp_2;
      try {
        tmp_2 = findPolymorphicSerializer(deserializer, this, type);
      } catch ($p) {
        var tmp_3;
        if ($p instanceof SerializationException) {
          var it = $p;
          throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
        } else {
          throw $p;
        }
      }
      var tmp_4 = tmp_2;
      var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
      tmp$ret$0 = readPolymorphicJson(this.u19(), discriminator, jsonTree, actualSerializer);
    }
    return tmp$ret$0;
  };
  protoOf(AbstractJsonTreeDecoder).z14 = function (parentName, childName) {
    return childName;
  };
  protoOf(AbstractJsonTreeDecoder).tq = function (descriptor) {
    var currentObject = this.b1g();
    var tmp0_subject = descriptor.xo();
    var tmp;
    var tmp_0;
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp_0 = true;
    } else {
      tmp_0 = tmp0_subject instanceof PolymorphicKind;
    }
    if (tmp_0) {
      var tmp_1 = this.u19();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = descriptor.wo();
      if (!(currentObject instanceof JsonArray)) {
        var tmp_2 = getKClass(JsonArray).cb();
        var tmp_3 = getKClassFromExpression(currentObject).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a15();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
      }
      tmp = new JsonTreeListDecoder(tmp_1, currentObject);
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var this_0 = this.u19();
        var keyDescriptor = carrierDescriptor(descriptor.ep(0), this_0.jo());
        var keyKind = keyDescriptor.xo();
        var tmp_4;
        var tmp_5;
        if (keyKind instanceof PrimitiveKind) {
          tmp_5 = true;
        } else {
          tmp_5 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_5) {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
          var tmp_6 = this.u19();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_0 = descriptor.wo();
          if (!(currentObject instanceof JsonObject)) {
            var tmp_7 = getKClass(JsonObject).cb();
            var tmp_8 = getKClassFromExpression(currentObject).cb();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
            var tmp$ret$3 = this.a15();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
          }
          tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
        } else {
          if (this_0.r17_1.g19_1) {
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.beginStructure.<anonymous>' call
            var tmp_9 = this.u19();
            // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
            // Inline function 'kotlinx.serialization.json.internal.cast' call
            var serialName_1 = descriptor.wo();
            if (!(currentObject instanceof JsonArray)) {
              var tmp_10 = getKClass(JsonArray).cb();
              var tmp_11 = getKClassFromExpression(currentObject).cb();
              // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
              var tmp$ret$7 = this.a15();
              throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
            }
            tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_4;
      } else {
        var tmp_12 = this.u19();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_2 = descriptor.wo();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_13 = getKClass(JsonObject).cb();
          var tmp_14 = getKClassFromExpression(currentObject).cb();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
          var tmp$ret$12 = this.a15();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
        }
        tmp = new JsonTreeDecoder(tmp_12, currentObject, this.y1f_1);
      }
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).uq = function (descriptor) {
  };
  protoOf(AbstractJsonTreeDecoder).eq = function () {
    var tmp = this.b1g();
    return !(tmp instanceof JsonNull);
  };
  protoOf(AbstractJsonTreeDecoder).d1g = function (tag, enumDescriptor) {
    var tmp = this.u19();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    var value = this.c1g(tag);
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = enumDescriptor.wo();
    if (!(value instanceof JsonPrimitive)) {
      var tmp_0 = getKClass(JsonPrimitive).cb();
      var tmp_1 = getKClassFromExpression(value).cb();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.a1g(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
    }
    return getJsonNameIndexOrThrow(enumDescriptor, tmp, value.z19());
  };
  protoOf(AbstractJsonTreeDecoder).m15 = function (tag, enumDescriptor) {
    return this.d1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).e1g = function (tag) {
    return !(this.c1g(tag) === JsonNull_getInstance());
  };
  protoOf(AbstractJsonTreeDecoder).c15 = function (tag) {
    return this.e1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).f1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        var tmp0_elvis_lhs = get_booleanOrNull(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'boolean', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).d15 = function (tag) {
    return this.f1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).g1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedByte.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-128 <= result ? result <= 127 : false) ? toByte(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'byte', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).e15 = function (tag) {
    return this.g1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).h1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedShort.<anonymous>' call
        var result = get_int(literal);
        var tmp0_elvis_lhs = (-32768 <= result ? result <= 32767 : false) ? toShort(result) : null;
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'short', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).f15 = function (tag) {
    return this.h1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).i1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedInt.<anonymous>' call
        var tmp0_elvis_lhs = get_int(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'int', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).g15 = function (tag) {
    return this.i1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).j1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedLong.<anonymous>' call
        var tmp0_elvis_lhs = get_long(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'long', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).h15 = function (tag) {
    return this.j1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).k1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedFloat.<anonymous>' call
        var tmp0_elvis_lhs = get_float(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'float', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.u19().r17_1.n19_1;
    if (specialFp || isFinite(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.b1g()));
  };
  protoOf(AbstractJsonTreeDecoder).i15 = function (tag) {
    return this.k1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).l1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedDouble.<anonymous>' call
        var tmp0_elvis_lhs = get_double(literal);
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'double', tag);
        } else {
          throw $p;
        }
      }
    }
    var result = tmp$ret$4;
    var specialFp = this.u19().r17_1.n19_1;
    if (specialFp || isFinite_0(result))
      return result;
    throw InvalidFloatingPointDecoded(result, tag, toString(this.b1g()));
  };
  protoOf(AbstractJsonTreeDecoder).j15 = function (tag) {
    return this.l1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).m1g = function (tag) {
    var tmp$ret$4;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var value = this.c1g(tag);
      if (!(value instanceof JsonPrimitive)) {
        var tmp = getKClass(JsonPrimitive).cb();
        var tmp_0 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
      }
      var literal = value;
      try {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.decodeTaggedChar.<anonymous>' call
        var tmp0_elvis_lhs = new Char(single(literal.z19()));
        var tmp_1;
        if (tmp0_elvis_lhs == null) {
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          tmp_1 = tmp0_elvis_lhs;
        }
        tmp$ret$4 = tmp_1.l1_1;
        break $l$block;
      } catch ($p) {
        if ($p instanceof IllegalArgumentException) {
          var e = $p;
          unparsedPrimitive(this, literal, 'char', tag);
        } else {
          throw $p;
        }
      }
    }
    return tmp$ret$4;
  };
  protoOf(AbstractJsonTreeDecoder).k15 = function (tag) {
    return this.m1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).n1g = function (tag) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.c1g(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).cb();
      var tmp_0 = getKClassFromExpression(value).cb();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
      var tmp$ret$0 = this.a1g(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var value_0 = value;
    if (!(value_0 instanceof JsonLiteral))
      throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.a1g(tag), toString(this.b1g()));
    if (!value_0.f1a_1 && !this.u19().r17_1.f19_1) {
      throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.a1g(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.b1g()));
    }
    return value_0.h1a_1;
  };
  protoOf(AbstractJsonTreeDecoder).l15 = function (tag) {
    return this.n1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
  };
  protoOf(AbstractJsonTreeDecoder).o1g = function (tag, inlineDescriptor) {
    var tmp;
    if (get_isUnsignedNumber(inlineDescriptor)) {
      var tmp_0 = this.u19();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.c1g(tag);
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = inlineDescriptor.wo();
      if (!(value instanceof JsonPrimitive)) {
        var tmp_1 = getKClass(JsonPrimitive).cb();
        var tmp_2 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a1g(tag);
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      var lexer = StringJsonLexer_0(tmp_0, value.z19());
      tmp = new JsonDecoderForUnsignedTypes(lexer, this.u19());
    } else {
      tmp = protoOf(NamedValueDecoder).n15.call(this, tag, inlineDescriptor);
    }
    return tmp;
  };
  protoOf(AbstractJsonTreeDecoder).n15 = function (tag, inlineDescriptor) {
    return this.o1g((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
  };
  protoOf(AbstractJsonTreeDecoder).qq = function (descriptor) {
    return !(this.y14() == null) ? protoOf(NamedValueDecoder).qq.call(this, descriptor) : (new JsonPrimitiveDecoder(this.u19(), this.w(), this.y1f_1)).qq(descriptor);
  };
  function coerceInputValue_0($this, descriptor, index, tag) {
    var tmp$ret$1;
    $l$block_2: {
      // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
      var this_0 = $this.u19();
      var isOptional = descriptor.fp(index);
      var elementDescriptor = descriptor.ep(index);
      var tmp;
      if (isOptional && !elementDescriptor.so()) {
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_0 = $this.c1g(tag);
        tmp = tmp_0 instanceof JsonNull;
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$1 = true;
        break $l$block_2;
      }
      if (equals(elementDescriptor.xo(), ENUM_getInstance())) {
        var tmp_1;
        if (elementDescriptor.so()) {
          // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
          var tmp_2 = $this.c1g(tag);
          tmp_1 = tmp_2 instanceof JsonNull;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$1 = false;
          break $l$block_2;
        }
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.coerceInputValue.<anonymous>' call
        var tmp_3 = $this.c1g(tag);
        var tmp0_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
        var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
        var tmp_4;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = false;
          break $l$block_2;
        } else {
          tmp_4 = tmp0_elvis_lhs;
        }
        var enumValue = tmp_4;
        var enumIndex = getJsonNameIndex(elementDescriptor, this_0, enumValue);
        var coerceToNull = !this_0.r17_1.i19_1 && elementDescriptor.so();
        if (enumIndex === -3 && (isOptional || coerceToNull)) {
          // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue.<anonymous>' call
          tmp$ret$1 = true;
          break $l$block_2;
        }
      }
      tmp$ret$1 = false;
    }
    return tmp$ret$1;
  }
  function absenceIsNull($this, descriptor, index) {
    $this.y1g_1 = (!$this.u19().r17_1.i19_1 && !descriptor.fp(index) && descriptor.ep(index).so());
    return $this.y1g_1;
  }
  function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.v1g_1 = value;
    this.w1g_1 = polyDescriptor;
    this.x1g_1 = 0;
    this.y1g_1 = false;
  }
  protoOf(JsonTreeDecoder).w = function () {
    return this.v1g_1;
  };
  protoOf(JsonTreeDecoder).jr = function (descriptor) {
    while (this.x1g_1 < descriptor.zo()) {
      var _unary__edvuaz = this.x1g_1;
      this.x1g_1 = _unary__edvuaz + 1 | 0;
      var name = this.t14(descriptor, _unary__edvuaz);
      var index = this.x1g_1 - 1 | 0;
      this.y1g_1 = false;
      var tmp;
      var tmp_0;
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_0 = this.w();
      if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).z1(name)) {
        tmp_0 = true;
      } else {
        tmp_0 = absenceIsNull(this, descriptor, index);
      }
      if (tmp_0) {
        tmp = !this.z1f_1.k19_1 || !coerceInputValue_0(this, descriptor, index, name);
      } else {
        tmp = false;
      }
      if (tmp) {
        return index;
      }
    }
    return -1;
  };
  protoOf(JsonTreeDecoder).eq = function () {
    return !this.y1g_1 && protoOf(AbstractJsonTreeDecoder).eq.call(this);
  };
  protoOf(JsonTreeDecoder).u14 = function (descriptor, index) {
    var strategy = namingStrategy(descriptor, this.u19());
    var baseName = descriptor.bp(index);
    if (strategy == null) {
      if (!this.z1f_1.o19_1)
        return baseName;
      if (this.w().c2().r(baseName))
        return baseName;
    }
    var deserializationNamesMap_0 = deserializationNamesMap(this.u19(), descriptor);
    // Inline function 'kotlin.collections.find' call
    var this_0 = this.w().c2();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'kotlinx.serialization.json.internal.JsonTreeDecoder.elementName.<anonymous>' call
        if (deserializationNamesMap_0.b2(element) === index) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver;
    }
    var fallbackName = strategy == null ? null : strategy.q1c(descriptor, index, baseName);
    return fallbackName == null ? baseName : fallbackName;
  };
  protoOf(JsonTreeDecoder).c1g = function (tag) {
    return getValue(this.w(), tag);
  };
  protoOf(JsonTreeDecoder).tq = function (descriptor) {
    if (descriptor === this.w1g_1) {
      var tmp = this.u19();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      var value = this.b1g();
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName = this.w1g_1.wo();
      if (!(value instanceof JsonObject)) {
        var tmp_0 = getKClass(JsonObject).cb();
        var tmp_1 = getKClassFromExpression(value).cb();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast.<anonymous>' call
        var tmp$ret$0 = this.a15();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(value));
      }
      return new JsonTreeDecoder(tmp, value, this.y1f_1, this.w1g_1);
    }
    return protoOf(AbstractJsonTreeDecoder).tq.call(this, descriptor);
  };
  protoOf(JsonTreeDecoder).uq = function (descriptor) {
    var tmp;
    if (this.z1f_1.e19_1) {
      tmp = true;
    } else {
      var tmp_0 = descriptor.xo();
      tmp = tmp_0 instanceof PolymorphicKind;
    }
    if (tmp)
      return Unit_instance;
    var strategy = namingStrategy(descriptor, this.u19());
    var tmp_1;
    if (strategy == null && !this.z1f_1.o19_1) {
      tmp_1 = jsonCachedSerialNames(descriptor);
    } else if (!(strategy == null)) {
      tmp_1 = deserializationNamesMap(this.u19(), descriptor).c2();
    } else {
      var tmp_2 = jsonCachedSerialNames(descriptor);
      // Inline function 'kotlin.collections.orEmpty' call
      var tmp0_safe_receiver = get_schemaCache(this.u19()).b1f(descriptor, get_JsonDeserializationNamesKey());
      var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c2();
      var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
      tmp_1 = plus_0(tmp_2, tmp$ret$0);
    }
    var names = tmp_1;
    var _iterator__ex2g4s = this.w().c2().g();
    while (_iterator__ex2g4s.h()) {
      var key = _iterator__ex2g4s.i();
      if (!names.r(key) && !(key === this.y1f_1)) {
        throw UnknownKeyException(key, this.w().toString());
      }
    }
  };
  function JsonTreeListDecoder(json, value) {
    AbstractJsonTreeDecoder.call(this, json, value);
    this.f1h_1 = value;
    this.g1h_1 = this.f1h_1.j();
    this.h1h_1 = -1;
  }
  protoOf(JsonTreeListDecoder).w = function () {
    return this.f1h_1;
  };
  protoOf(JsonTreeListDecoder).u14 = function (descriptor, index) {
    return index.toString();
  };
  protoOf(JsonTreeListDecoder).c1g = function (tag) {
    return this.f1h_1.l(toInt(tag));
  };
  protoOf(JsonTreeListDecoder).jr = function (descriptor) {
    while (this.h1h_1 < (this.g1h_1 - 1 | 0)) {
      this.h1h_1 = this.h1h_1 + 1 | 0;
      return this.h1h_1;
    }
    return -1;
  };
  function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
    polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
    AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
    this.o1h_1 = value;
    this.o15('primitive');
  }
  protoOf(JsonPrimitiveDecoder).w = function () {
    return this.o1h_1;
  };
  protoOf(JsonPrimitiveDecoder).jr = function (descriptor) {
    return 0;
  };
  protoOf(JsonPrimitiveDecoder).c1g = function (tag) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(tag === 'primitive')) {
      // Inline function 'kotlinx.serialization.json.internal.JsonPrimitiveDecoder.currentElement.<anonymous>' call
      var message = "This input can only handle primitives with 'primitive' tag";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.o1h_1;
  };
  function JsonTreeMapDecoder(json, value) {
    JsonTreeDecoder.call(this, json, value);
    this.z1h_1 = value;
    this.a1i_1 = toList(this.z1h_1.c2());
    this.b1i_1 = imul(this.a1i_1.j(), 2);
    this.c1i_1 = -1;
  }
  protoOf(JsonTreeMapDecoder).w = function () {
    return this.z1h_1;
  };
  protoOf(JsonTreeMapDecoder).u14 = function (descriptor, index) {
    var i = index / 2 | 0;
    return this.a1i_1.l(i);
  };
  protoOf(JsonTreeMapDecoder).jr = function (descriptor) {
    while (this.c1i_1 < (this.b1i_1 - 1 | 0)) {
      this.c1i_1 = this.c1i_1 + 1 | 0;
      return this.c1i_1;
    }
    return -1;
  };
  protoOf(JsonTreeMapDecoder).c1g = function (tag) {
    return (this.c1i_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.z1h_1, tag);
  };
  protoOf(JsonTreeMapDecoder).uq = function (descriptor) {
  };
  function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
    return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.nn())).sq(deserializer);
  }
  var WriteMode_OBJ_instance;
  var WriteMode_LIST_instance;
  var WriteMode_MAP_instance;
  var WriteMode_POLY_OBJ_instance;
  function values() {
    return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var WriteMode_entriesInitialized;
  function WriteMode_initEntries() {
    if (WriteMode_entriesInitialized)
      return Unit_instance;
    WriteMode_entriesInitialized = true;
    WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
    WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
    WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  }
  var $ENTRIES;
  function WriteMode(name, ordinal, begin, end) {
    Enum.call(this, name, ordinal);
    this.o1f_1 = begin;
    this.p1f_1 = end;
  }
  function switchMode(_this__u8e3s4, desc) {
    var tmp0_subject = desc.xo();
    var tmp;
    if (tmp0_subject instanceof PolymorphicKind) {
      tmp = WriteMode_POLY_OBJ_getInstance();
    } else {
      if (equals(tmp0_subject, LIST_getInstance())) {
        tmp = WriteMode_LIST_getInstance();
      } else {
        if (equals(tmp0_subject, MAP_getInstance())) {
          // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
          var keyDescriptor = carrierDescriptor(desc.ep(0), _this__u8e3s4.jo());
          var keyKind = keyDescriptor.xo();
          var tmp_0;
          var tmp_1;
          if (keyKind instanceof PrimitiveKind) {
            tmp_1 = true;
          } else {
            tmp_1 = equals(keyKind, ENUM_getInstance());
          }
          if (tmp_1) {
            // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
            tmp_0 = WriteMode_MAP_getInstance();
          } else {
            if (_this__u8e3s4.r17_1.g19_1) {
              // Inline function 'kotlinx.serialization.json.internal.switchMode.<anonymous>' call
              tmp_0 = WriteMode_LIST_getInstance();
            } else {
              throw InvalidKeyKindException(keyDescriptor);
            }
          }
          tmp = tmp_0;
        } else {
          tmp = WriteMode_OBJ_getInstance();
        }
      }
    }
    return tmp;
  }
  function carrierDescriptor(_this__u8e3s4, module_0) {
    var tmp;
    if (equals(_this__u8e3s4.xo(), CONTEXTUAL_getInstance())) {
      var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
      tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
    } else if (_this__u8e3s4.yo()) {
      tmp = carrierDescriptor(_this__u8e3s4.ep(0), module_0);
    } else {
      tmp = _this__u8e3s4;
    }
    return tmp;
  }
  function WriteMode_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_OBJ_instance;
  }
  function WriteMode_LIST_getInstance() {
    WriteMode_initEntries();
    return WriteMode_LIST_instance;
  }
  function WriteMode_MAP_getInstance() {
    WriteMode_initEntries();
    return WriteMode_MAP_instance;
  }
  function WriteMode_POLY_OBJ_getInstance() {
    WriteMode_initEntries();
    return WriteMode_POLY_OBJ_instance;
  }
  function appendEscape($this, lastPosition, current) {
    $this.d1i(lastPosition, current);
    return appendEsc($this, current + 1 | 0);
  }
  function decodedString($this, lastPosition, currentPosition) {
    $this.d1i(lastPosition, currentPosition);
    var result = $this.i18_1.toString();
    $this.i18_1.yc(0);
    return result;
  }
  function takePeeked($this) {
    // Inline function 'kotlin.also' call
    var this_0 = ensureNotNull($this.h18_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.takePeeked.<anonymous>' call
    $this.h18_1 = null;
    return this_0;
  }
  function wasUnquotedString($this) {
    return !(charSequenceGet($this.e1i(), $this.f18_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
  }
  function appendEsc($this, startPosition) {
    var currentPosition = startPosition;
    currentPosition = $this.f1i(currentPosition);
    if (currentPosition === -1) {
      $this.m1c('Expected escape sequence to continue, got EOF');
    }
    var tmp = $this.e1i();
    var _unary__edvuaz = currentPosition;
    currentPosition = _unary__edvuaz + 1 | 0;
    var currentChar = charSequenceGet(tmp, _unary__edvuaz);
    if (currentChar === _Char___init__impl__6a9atx(117)) {
      return appendHex($this, $this.e1i(), currentPosition);
    }
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
    var c = escapeToChar(tmp$ret$0);
    if (c === _Char___init__impl__6a9atx(0)) {
      $this.m1c("Invalid escaped char '" + toString_1(currentChar) + "'");
    }
    $this.i18_1.j8(c);
    return currentPosition;
  }
  function appendHex($this, source, startPos) {
    if ((startPos + 4 | 0) >= charSequenceLength(source)) {
      $this.f18_1 = startPos;
      $this.g1i();
      if (($this.f18_1 + 4 | 0) >= charSequenceLength(source)) {
        $this.m1c('Unexpected EOF during unicode escape');
      }
      return appendHex($this, source, $this.f18_1);
    }
    $this.i18_1.j8(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
    return startPos + 4 | 0;
  }
  function fromHexChar($this, source, currentPosition) {
    var character = charSequenceGet(source, currentPosition);
    var tmp;
    if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
      // Inline function 'kotlin.code' call
      var tmp_1 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(97);
      tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
    } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
      // Inline function 'kotlin.code' call
      var tmp_2 = Char__toInt_impl_vasixd(character);
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
    } else {
      $this.m1c("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
    }
    return tmp;
  }
  function consumeBoolean2($this, start) {
    var current = $this.f1i(start);
    if (current >= charSequenceLength($this.e1i()) || current === -1) {
      $this.m1c('EOF');
    }
    // Inline function 'kotlin.code' call
    var tmp = $this.e1i();
    var _unary__edvuaz = current;
    current = _unary__edvuaz + 1 | 0;
    var this_0 = charSequenceGet(tmp, _unary__edvuaz);
    var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
    var tmp_0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(116);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
      consumeBooleanLiteral($this, 'rue', current);
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(102);
      if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
        consumeBooleanLiteral($this, 'alse', current);
        tmp_0 = false;
      } else {
        $this.m1c("Expected valid boolean literal prefix, but had '" + $this.r1d() + "'");
      }
    }
    return tmp_0;
  }
  function consumeBooleanLiteral($this, literalSuffix, current) {
    if ((charSequenceLength($this.e1i()) - current | 0) < literalSuffix.length) {
      $this.m1c('Unexpected end of boolean literal');
    }
    var inductionVariable = 0;
    var last = charSequenceLength(literalSuffix) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var expected = charSequenceGet(literalSuffix, i);
        var actual = charSequenceGet($this.e1i(), current + i | 0);
        // Inline function 'kotlin.code' call
        var tmp = Char__toInt_impl_vasixd(expected);
        // Inline function 'kotlin.code' call
        if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
          $this.m1c("Expected valid boolean literal prefix, but had '" + $this.r1d() + "'");
        }
      }
       while (inductionVariable <= last);
    $this.f18_1 = current + literalSuffix.length | 0;
  }
  function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
    var tmp;
    switch (isExponentPositive) {
      case false:
        // Inline function 'kotlin.math.pow' call

        var x = -exponentAccumulator.l3();
        tmp = Math.pow(10.0, x);
        break;
      case true:
        // Inline function 'kotlin.math.pow' call

        var x_0 = exponentAccumulator.l3();
        tmp = Math.pow(10.0, x_0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function AbstractJsonLexer() {
    this.f18_1 = 0;
    this.g18_1 = new JsonPath();
    this.h18_1 = null;
    this.i18_1 = StringBuilder_init_$Create$();
  }
  protoOf(AbstractJsonLexer).g1i = function () {
  };
  protoOf(AbstractJsonLexer).e1f = function () {
    var current = this.h1i();
    var source = this.e1i();
    if (current >= charSequenceLength(source) || current === -1)
      return false;
    if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
      this.f18_1 = this.f18_1 + 1 | 0;
      return true;
    }
    return false;
  };
  protoOf(AbstractJsonLexer).i1i = function (c) {
    return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
  };
  protoOf(AbstractJsonLexer).j18 = function () {
    var nextToken = this.t1d();
    if (!(nextToken === 10)) {
      this.m1c('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.e1i(), this.f18_1 - 1 | 0)) + ' instead');
    }
  };
  protoOf(AbstractJsonLexer).n1d = function (expected) {
    var token = this.t1d();
    if (!(token === expected)) {
      this.j1i(expected);
    }
    return token;
  };
  protoOf(AbstractJsonLexer).k1i = function (expected) {
    if (this.f18_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
        var snapshot = this.f18_1;
        try {
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.unexpectedToken.<anonymous>' call
          this.f18_1 = this.f18_1 - 1 | 0;
          tmp$ret$1 = this.r1d();
          break $l$block;
        }finally {
          this.f18_1 = snapshot;
        }
      }
      var inputLiteral = tmp$ret$1;
      if (inputLiteral === 'null') {
        this.l1c("Expected string literal but 'null' literal was found", this.f18_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
      }
    }
    this.j1i(charToTokenClass(expected));
  };
  protoOf(AbstractJsonLexer).l1i = function (expectedToken, wasConsumed) {
    var expected = tokenDescription(expectedToken);
    var position = wasConsumed ? this.f18_1 - 1 | 0 : this.f18_1;
    var s = this.f18_1 === charSequenceLength(this.e1i()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.e1i(), position));
    this.m1c('Expected ' + expected + ", but had '" + s + "' instead", position);
  };
  protoOf(AbstractJsonLexer).j1i = function (expectedToken, wasConsumed, $super) {
    wasConsumed = wasConsumed === VOID ? true : wasConsumed;
    return $super === VOID ? this.l1i(expectedToken, wasConsumed) : $super.l1i.call(this, expectedToken, wasConsumed);
  };
  protoOf(AbstractJsonLexer).o1d = function () {
    var source = this.e1i();
    var cpos = this.f18_1;
    $l$loop_0: while (true) {
      cpos = this.f1i(cpos);
      if (cpos === -1)
        break $l$loop_0;
      var ch = charSequenceGet(source, cpos);
      if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
        cpos = cpos + 1 | 0;
        continue $l$loop_0;
      }
      this.f18_1 = cpos;
      return charToTokenClass(ch);
    }
    this.f18_1 = cpos;
    return 10;
  };
  protoOf(AbstractJsonLexer).f1f = function (doConsume) {
    var current = this.h1i();
    current = this.f1i(current);
    var len = charSequenceLength(this.e1i()) - current | 0;
    if (len < 4 || current === -1)
      return false;
    var inductionVariable = 0;
    if (inductionVariable <= 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(charSequenceGet('null', i) === charSequenceGet(this.e1i(), current + i | 0)))
          return false;
      }
       while (inductionVariable <= 3);
    if (len > 4 && charToTokenClass(charSequenceGet(this.e1i(), current + 4 | 0)) === 0)
      return false;
    if (doConsume) {
      this.f18_1 = current + 4 | 0;
    }
    return true;
  };
  protoOf(AbstractJsonLexer).q1f = function (doConsume, $super) {
    doConsume = doConsume === VOID ? true : doConsume;
    return $super === VOID ? this.f1f(doConsume) : $super.f1f.call(this, doConsume);
  };
  protoOf(AbstractJsonLexer).g1f = function (isLenient) {
    var token = this.o1d();
    var tmp;
    if (isLenient) {
      if (!(token === 1) && !(token === 0))
        return null;
      tmp = this.r1d();
    } else {
      if (!(token === 1))
        return null;
      tmp = this.q1d();
    }
    var string = tmp;
    this.h18_1 = string;
    return string;
  };
  protoOf(AbstractJsonLexer).m1i = function () {
    this.h18_1 = null;
  };
  protoOf(AbstractJsonLexer).n1i = function (startPos, endPos) {
    // Inline function 'kotlin.text.substring' call
    var this_0 = this.e1i();
    return toString(charSequenceSubSequence(this_0, startPos, endPos));
  };
  protoOf(AbstractJsonLexer).q1d = function () {
    if (!(this.h18_1 == null)) {
      return takePeeked(this);
    }
    return this.j1f();
  };
  protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
    var currentPosition = current;
    var lastPosition = startPosition;
    var char = charSequenceGet(source, currentPosition);
    var usedAppend = false;
    while (!(char === _Char___init__impl__6a9atx(34))) {
      if (char === _Char___init__impl__6a9atx(92)) {
        usedAppend = true;
        currentPosition = this.f1i(appendEscape(this, lastPosition, currentPosition));
        if (currentPosition === -1) {
          this.m1c('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      } else {
        currentPosition = currentPosition + 1 | 0;
        if (currentPosition >= charSequenceLength(source)) {
          usedAppend = true;
          this.d1i(lastPosition, currentPosition);
          currentPosition = this.f1i(currentPosition);
          if (currentPosition === -1) {
            this.m1c('Unexpected EOF', currentPosition);
          }
          lastPosition = currentPosition;
        }
      }
      char = charSequenceGet(source, currentPosition);
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.n1i(lastPosition, currentPosition);
    } else {
      tmp = decodedString(this, lastPosition, currentPosition);
    }
    var string = tmp;
    this.f18_1 = currentPosition + 1 | 0;
    return string;
  };
  protoOf(AbstractJsonLexer).k1f = function () {
    var result = this.r1d();
    if (result === 'null' && wasUnquotedString(this)) {
      this.m1c("Unexpected 'null' value instead of string literal");
    }
    return result;
  };
  protoOf(AbstractJsonLexer).r1d = function () {
    if (!(this.h18_1 == null)) {
      return takePeeked(this);
    }
    var current = this.h1i();
    if (current >= charSequenceLength(this.e1i()) || current === -1) {
      this.m1c('EOF', current);
    }
    var token = charToTokenClass(charSequenceGet(this.e1i(), current));
    if (token === 1) {
      return this.q1d();
    }
    if (!(token === 0)) {
      this.m1c('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.e1i(), current)));
    }
    var usedAppend = false;
    while (charToTokenClass(charSequenceGet(this.e1i(), current)) === 0) {
      current = current + 1 | 0;
      if (current >= charSequenceLength(this.e1i())) {
        usedAppend = true;
        this.d1i(this.f18_1, current);
        var eof = this.f1i(current);
        if (eof === -1) {
          this.f18_1 = current;
          return decodedString(this, 0, 0);
        } else {
          current = eof;
        }
      }
    }
    var tmp;
    if (!usedAppend) {
      tmp = this.n1i(this.f18_1, current);
    } else {
      tmp = decodedString(this, this.f18_1, current);
    }
    var result = tmp;
    this.f18_1 = current;
    return result;
  };
  protoOf(AbstractJsonLexer).d1i = function (fromIndex, toIndex) {
    this.i18_1.sc(this.e1i(), fromIndex, toIndex);
  };
  protoOf(AbstractJsonLexer).i1f = function (allowLenientStrings) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var tokenStack = ArrayList_init_$Create$();
    var lastToken = this.o1d();
    if (!(lastToken === 8) && !(lastToken === 6)) {
      this.r1d();
      return Unit_instance;
    }
    $l$loop: while (true) {
      lastToken = this.o1d();
      if (lastToken === 1) {
        if (allowLenientStrings)
          this.r1d();
        else
          this.j1f();
        continue $l$loop;
      }
      var tmp0_subject = lastToken;
      if (tmp0_subject === 8 || tmp0_subject === 6) {
        tokenStack.e(lastToken);
      } else if (tmp0_subject === 9) {
        if (!(last(tokenStack) === 8))
          throw JsonDecodingException_0(this.f18_1, 'found ] instead of } at path: ' + this.g18_1.toString(), this.e1i());
        removeLast(tokenStack);
      } else if (tmp0_subject === 7) {
        if (!(last(tokenStack) === 6))
          throw JsonDecodingException_0(this.f18_1, 'found } instead of ] at path: ' + this.g18_1.toString(), this.e1i());
        removeLast(tokenStack);
      } else if (tmp0_subject === 10) {
        this.m1c('Unexpected end of input due to malformed JSON during ignoring unknown keys');
      }
      this.t1d();
      if (tokenStack.j() === 0)
        return Unit_instance;
    }
  };
  protoOf(AbstractJsonLexer).toString = function () {
    return "JsonReader(source='" + toString(this.e1i()) + "', currentPosition=" + this.f18_1 + ')';
  };
  protoOf(AbstractJsonLexer).h1f = function (key) {
    var processed = this.n1i(0, this.f18_1);
    var lastIndexOf_0 = lastIndexOf(processed, key);
    this.l1c("Encountered an unknown key '" + key + "'", lastIndexOf_0, "Use 'ignoreUnknownKeys = true' in 'Json {}' builder to ignore unknown keys.");
  };
  protoOf(AbstractJsonLexer).l1c = function (message, position, hint) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(hint) === 0) {
      tmp = '';
    } else {
      tmp = '\n' + hint;
    }
    var hintMessage = tmp;
    throw JsonDecodingException_0(position, message + ' at path: ' + this.g18_1.z1c() + hintMessage, this.e1i());
  };
  protoOf(AbstractJsonLexer).m1c = function (message, position, hint, $super) {
    position = position === VOID ? this.f18_1 : position;
    hint = hint === VOID ? '' : hint;
    return $super === VOID ? this.l1c(message, position, hint) : $super.l1c.call(this, message, position, hint);
  };
  protoOf(AbstractJsonLexer).i1a = function () {
    var current = this.h1i();
    current = this.f1i(current);
    if (current >= charSequenceLength(this.e1i()) || current === -1) {
      this.m1c('EOF');
    }
    var tmp;
    if (charSequenceGet(this.e1i(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      if (current === charSequenceLength(this.e1i())) {
        this.m1c('EOF');
      }
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var accumulator = new Long(0, 0);
    var exponentAccumulator = new Long(0, 0);
    var isNegative = false;
    var isExponentPositive = false;
    var hasExponent = false;
    var start = current;
    $l$loop_4: while (!(current === charSequenceLength(this.e1i()))) {
      var ch = charSequenceGet(this.e1i(), current);
      if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
        if (current === start) {
          this.m1c('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
        }
        isExponentPositive = true;
        hasExponent = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
        if (current === start) {
          this.m1c("Unexpected symbol '-' in numeric literal");
        }
        isExponentPositive = false;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
        if (current === start) {
          this.m1c("Unexpected symbol '+' in numeric literal");
        }
        isExponentPositive = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      if (ch === _Char___init__impl__6a9atx(45)) {
        if (!(current === start)) {
          this.m1c("Unexpected symbol '-' in numeric literal");
        }
        isNegative = true;
        current = current + 1 | 0;
        continue $l$loop_4;
      }
      var token = charToTokenClass(ch);
      if (!(token === 0))
        break $l$loop_4;
      current = current + 1 | 0;
      var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
      if (!(0 <= digit ? digit <= 9 : false)) {
        this.m1c("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
      }
      if (hasExponent) {
        // Inline function 'kotlin.Long.plus' call
        // Inline function 'kotlin.Long.times' call
        exponentAccumulator = exponentAccumulator.w2(toLong(10)).u2(toLong(digit));
        continue $l$loop_4;
      }
      // Inline function 'kotlin.Long.minus' call
      // Inline function 'kotlin.Long.times' call
      accumulator = accumulator.w2(toLong(10)).v2(toLong(digit));
      if (accumulator.e1(new Long(0, 0)) > 0) {
        this.m1c('Numeric value overflow');
      }
    }
    var hasChars = !(current === start);
    if (start === current || (isNegative && start === (current - 1 | 0))) {
      this.m1c('Expected numeric literal');
    }
    if (hasQuotation) {
      if (!hasChars) {
        this.m1c('EOF');
      }
      if (!(charSequenceGet(this.e1i(), current) === _Char___init__impl__6a9atx(34))) {
        this.m1c('Expected closing quotation mark');
      }
      current = current + 1 | 0;
    }
    this.f18_1 = current;
    if (hasExponent) {
      var doubleAccumulator = accumulator.l3() * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
      if (doubleAccumulator > (new Long(-1, 2147483647)).l3() || doubleAccumulator < (new Long(0, -2147483648)).l3()) {
        this.m1c('Numeric value overflow');
      }
      // Inline function 'kotlin.math.floor' call
      if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
        this.m1c("Can't convert " + doubleAccumulator + ' to Long');
      }
      accumulator = numberToLong(doubleAccumulator);
    }
    var tmp_0;
    if (isNegative) {
      tmp_0 = accumulator;
    } else if (!accumulator.equals(new Long(0, -2147483648))) {
      tmp_0 = accumulator.b3();
    } else {
      this.m1c('Numeric value overflow');
    }
    return tmp_0;
  };
  protoOf(AbstractJsonLexer).r1f = function () {
    var current = this.h1i();
    if (current === charSequenceLength(this.e1i())) {
      this.m1c('EOF');
    }
    var tmp;
    if (charSequenceGet(this.e1i(), current) === _Char___init__impl__6a9atx(34)) {
      current = current + 1 | 0;
      tmp = true;
    } else {
      tmp = false;
    }
    var hasQuotation = tmp;
    var result = consumeBoolean2(this, current);
    if (hasQuotation) {
      if (this.f18_1 === charSequenceLength(this.e1i())) {
        this.m1c('EOF');
      }
      if (!(charSequenceGet(this.e1i(), this.f18_1) === _Char___init__impl__6a9atx(34))) {
        this.m1c('Expected closing quotation mark');
      }
      this.f18_1 = this.f18_1 + 1 | 0;
    }
    return result;
  };
  function charToTokenClass(c) {
    var tmp;
    // Inline function 'kotlin.code' call
    if (Char__toInt_impl_vasixd(c) < 126) {
      var tmp_0 = CharMappings_getInstance().p1i_1;
      // Inline function 'kotlin.code' call
      tmp = tmp_0[Char__toInt_impl_vasixd(c)];
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function tokenDescription(token) {
    return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
  }
  function escapeToChar(c) {
    return c < 117 ? CharMappings_getInstance().o1i_1[c] : _Char___init__impl__6a9atx(0);
  }
  function initEscape($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2ESC($this, i, _Char___init__impl__6a9atx(117));
      }
       while (inductionVariable <= 31);
    initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
    initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
    initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
    initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
    initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
    initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
    initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
    initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
  }
  function initCharToToken($this) {
    var inductionVariable = 0;
    if (inductionVariable <= 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        initC2TC($this, i, 127);
      }
       while (inductionVariable <= 32);
    initC2TC($this, 9, 3);
    initC2TC($this, 10, 3);
    initC2TC($this, 13, 3);
    initC2TC($this, 32, 3);
    initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
    initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
    initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
    initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
    initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
    initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
    initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
    initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
  }
  function initC2ESC($this, c, esc) {
    if (!(esc === _Char___init__impl__6a9atx(117))) {
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
      $this.o1i_1[tmp$ret$0] = numberToChar(c);
    }
  }
  function initC2ESC_0($this, c, esc) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2ESC($this, tmp$ret$0, esc);
  }
  function initC2TC($this, c, cl) {
    $this.p1i_1[c] = cl;
  }
  function initC2TC_0($this, c, cl) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(c);
    return initC2TC($this, tmp$ret$0, cl);
  }
  function CharMappings() {
    CharMappings_instance = this;
    this.o1i_1 = charArray(117);
    this.p1i_1 = new Int8Array(126);
    initEscape(this);
    initCharToToken(this);
  }
  var CharMappings_instance;
  function CharMappings_getInstance() {
    if (CharMappings_instance == null)
      new CharMappings();
    return CharMappings_instance;
  }
  function StringJsonLexerWithComments(source) {
    StringJsonLexer.call(this, source);
  }
  protoOf(StringJsonLexerWithComments).t1d = function () {
    var source = this.e1i();
    var cpos = this.h1i();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.f18_1 = cpos + 1 | 0;
    return charToTokenClass(charSequenceGet(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).p1d = function () {
    var current = this.h1i();
    if (current >= this.e1i().length || current === -1)
      return false;
    return this.i1i(charSequenceGet(this.e1i(), current));
  };
  protoOf(StringJsonLexerWithComments).d1f = function (expected) {
    var source = this.e1i();
    var current = this.h1i();
    if (current >= source.length || current === -1) {
      this.f18_1 = -1;
      this.k1i(expected);
    }
    var c = charSequenceGet(source, current);
    this.f18_1 = current + 1 | 0;
    if (c === expected)
      return Unit_instance;
    else {
      this.k1i(expected);
    }
  };
  protoOf(StringJsonLexerWithComments).o1d = function () {
    var source = this.e1i();
    var cpos = this.h1i();
    if (cpos >= source.length || cpos === -1)
      return 10;
    this.f18_1 = cpos;
    return charToTokenClass(charSequenceGet(source, cpos));
  };
  protoOf(StringJsonLexerWithComments).h1i = function () {
    var current = this.f18_1;
    if (current === -1)
      return current;
    var source = this.e1i();
    $l$loop_1: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop_1;
      }
      if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
        var tmp0_subject = charSequenceGet(source, current + 1 | 0);
        if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
          current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
          if (current === -1) {
            current = source.length;
          } else {
            current = current + 1 | 0;
          }
          continue $l$loop_1;
        } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
          current = indexOf(source, '*/', current + 2 | 0);
          if (current === -1) {
            this.f18_1 = source.length;
            this.m1c('Expected end of the block comment: "*/", but had EOF instead');
          } else {
            current = current + 2 | 0;
          }
          continue $l$loop_1;
        }
      }
      break $l$loop_1;
    }
    this.f18_1 = current;
    return current;
  };
  function StringJsonLexer(source) {
    AbstractJsonLexer.call(this);
    this.z1i_1 = source;
  }
  protoOf(StringJsonLexer).e1i = function () {
    return this.z1i_1;
  };
  protoOf(StringJsonLexer).f1i = function (position) {
    return position < this.e1i().length ? position : -1;
  };
  protoOf(StringJsonLexer).t1d = function () {
    var source = this.e1i();
    var cpos = this.f18_1;
    $l$loop: while (!(cpos === -1) && cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.f18_1 = cpos;
      return charToTokenClass(c);
    }
    this.f18_1 = source.length;
    return 10;
  };
  protoOf(StringJsonLexer).p1d = function () {
    var current = this.f18_1;
    if (current === -1)
      return false;
    var source = this.e1i();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
        continue $l$loop;
      }
      this.f18_1 = current;
      return this.i1i(c);
    }
    this.f18_1 = current;
    return false;
  };
  protoOf(StringJsonLexer).h1i = function () {
    var current = this.f18_1;
    if (current === -1)
      return current;
    var source = this.e1i();
    $l$loop: while (current < source.length) {
      var c = charSequenceGet(source, current);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
        current = current + 1 | 0;
      } else {
        break $l$loop;
      }
    }
    this.f18_1 = current;
    return current;
  };
  protoOf(StringJsonLexer).d1f = function (expected) {
    if (this.f18_1 === -1) {
      this.k1i(expected);
    }
    var source = this.e1i();
    var cpos = this.f18_1;
    $l$loop: while (cpos < source.length) {
      var _unary__edvuaz = cpos;
      cpos = _unary__edvuaz + 1 | 0;
      var c = charSequenceGet(source, _unary__edvuaz);
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
      if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
        continue $l$loop;
      this.f18_1 = cpos;
      if (c === expected)
        return Unit_instance;
      this.k1i(expected);
    }
    this.f18_1 = -1;
    this.k1i(expected);
  };
  protoOf(StringJsonLexer).j1f = function () {
    this.d1f(_Char___init__impl__6a9atx(34));
    var current = this.f18_1;
    var closingQuote = indexOf_0(this.e1i(), _Char___init__impl__6a9atx(34), current);
    if (closingQuote === -1) {
      this.r1d();
      this.l1i(1, false);
    }
    var inductionVariable = current;
    if (inductionVariable < closingQuote)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (charSequenceGet(this.e1i(), i) === _Char___init__impl__6a9atx(92)) {
          return this.consumeString2(this.e1i(), this.f18_1, i);
        }
      }
       while (inductionVariable < closingQuote);
    this.f18_1 = closingQuote + 1 | 0;
    // Inline function 'kotlin.text.substring' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.e1i().substring(current, closingQuote);
  };
  protoOf(StringJsonLexer).l1f = function (keyToMatch, isLenient) {
    var positionSnapshot = this.f18_1;
    try {
      if (!(this.t1d() === 6))
        return null;
      var firstKey = this.g1f(isLenient);
      if (!(firstKey === keyToMatch))
        return null;
      this.m1i();
      if (!(this.t1d() === 5))
        return null;
      return this.g1f(isLenient);
    }finally {
      this.f18_1 = positionSnapshot;
      this.m1i();
    }
  };
  function StringJsonLexer_0(json, source) {
    return !json.r17_1.s19_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
  }
  function get_schemaCache(_this__u8e3s4) {
    return _this__u8e3s4.t17_1;
  }
  function JsonToStringWriter() {
    this.v17_1 = StringBuilder_init_$Create$_0(128);
  }
  protoOf(JsonToStringWriter).q1b = function (value) {
    this.v17_1.wc(value);
  };
  protoOf(JsonToStringWriter).k1b = function (char) {
    this.v17_1.j8(char);
  };
  protoOf(JsonToStringWriter).m1b = function (text) {
    this.v17_1.i8(text);
  };
  protoOf(JsonToStringWriter).w1b = function (text) {
    printQuoted(this.v17_1, text);
  };
  protoOf(JsonToStringWriter).w17 = function () {
    this.v17_1.zc();
  };
  protoOf(JsonToStringWriter).toString = function () {
    return this.v17_1.toString();
  };
  function createMapForCache(initialCapacity) {
    return HashMap_init_$Create$(initialCapacity);
  }
  //region block: post-declaration
  protoOf(defer$1).so = get_isNullable;
  protoOf(defer$1).yo = get_isInline;
  protoOf(defer$1).ap = get_annotations;
  protoOf(PolymorphismValidator).k17 = contextual;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Tombstone_instance = new Tombstone();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Default_getInstance;
  _.$_$.b = Companion_instance;
  _.$_$.c = JsonNull_getInstance;
  _.$_$.d = JsonArray;
  _.$_$.e = JsonElement;
  _.$_$.f = JsonObjectBuilder;
  _.$_$.g = JsonObject;
  _.$_$.h = JsonPrimitive_0;
  _.$_$.i = JsonPrimitive_1;
  _.$_$.j = Json_0;
  _.$_$.k = put_0;
  _.$_$.l = put;
  //endregion
  return _;
}));
